image.png<template>
  <div class="content_son">

    <!-- 左侧导航栏 -->
    <consultationControlClass
      :classData="classData"
      :currentChatId="itemCacheChatData?.chatId || ''"
      @clickChatClass="clickChatClass"
      @refreshData="refreshData"
      @joinChat="joinChat"
      @statusBtn="statusBtn"
      @updateStatusBtn="updateStatusBtn"
      @viewMedicalDetail="handleViewMedicalDetail"
      class="chatClass"
      ref="chatClass"
      :style="{ width: leftPanelWidth - 10 + 'px' }"
    />
    <!-- 左中面板分隔符 -->
    <div
      class="panel-divider"
      @mousedown="startResize('left')"
      :style="{ left: leftPanelWidth + 'px' }"
    >
      <div class="divider-handle"></div>
    </div>
    <!-- 病历提取,修改，分析 -->
    <div
      class="medical_record"
      :style="{
      left: leftPanelWidth + 10 + 'px',
      right: rightPanelWidth + 10 + 'px'
    }"
    >
      <div class="top">
        <div class="btn" style="display: flex;" v-if="false">
          <el-tooltip class="item" effect="dark" :open-delay=800 content="查看聊天会话历史" placement="top">
            <button class="icon-btn" @click="openConversationHistory">
              <i class="el-icon-time"></i>
            </button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :open-delay=800 content="撤销上一步操作" placement="top">
            <button class="icon-btn">
              <img src="/icons/undo.svg" alt="撤销" class="icon-img" />
            </button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :open-delay=800 content="重做上一步操作" placement="top">
            <button class="icon-btn">
              <img src="/icons/redo.svg" alt="重做" class="icon-img" />
            </button>
          </el-tooltip>
        </div>
        <div>
          <!-- 重置病历按钮已移除 -->
          <el-popover placement="top" v-model="resetVisible" v-if="false">
            <div class="popover-content">
              <div class="title">
                <i class="el-icon-warning"></i>确认重置病历？
              </div>
              <div class="txt">将要恢复到预问诊病历的状态，请谨慎操作！</div>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="resetVisible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="confirmResetMedicalRecord">确定</el-button>
            </div>
            <template #reference>
              <el-tooltip
                class="item"
                :open-delay=800
                effect="dark"
                content="重置病历到预问诊状态，请谨慎操作"
                placement="top"
              >
                <el-button
                  size="small"
                  class="reset-btn-like-reject"
                >
                  <i class="el-icon-refresh"></i>重置病历
                </el-button>
              </el-tooltip>
            </template>
          </el-popover>

          </div>

        <div >
          <el-tag
              v-if="itemCacheChatData.id"
              type="success"
              size="mini"
              style="margin:0px 20px 10px;display:None;">
            当前会话ID：{{itemCacheChatData.id}}</el-tag>
        </div>
        <div class="right">

          <el-tooltip
            class="item"
            :open-delay="800"
            effect="dark"
            content="复制当前页面全部病历内容"
            placement="top"
          >
            <div class="hisbtn" style="margin-right: 8px;" @click="copyCurrentPageContent">
              <i class="el-icon-document-copy"></i>复制本页
            </div>
          </el-tooltip>

          <el-tooltip
            class="item"
            :open-delay=800
            effect="dark"
            content="提交病历到HIS系统"
            placement="top"
          >
            <div class="hisbtn" @click="hisSub = true">
              <i class="el-icon-upload2"></i>HIS提交
            </div>
          </el-tooltip>

        </div>
      </div>
      <!-- xhduan type1-->
      <div class="center" v-if="itemCacheChatData && itemCacheChatData.id">
        <div v-if="type==1" class="chatBox_center">
          <ChatBox ref="chatBox" :chatData="chatData" :class="'chat_dom_center'" :loading="loading"></ChatBox>
        </div>
        <div v-if="type==2" class="medical">
          <!-- 病例详情展示（点击左侧病历记录联动） -->
          <div class="medical-detail" v-if="medicalDetail && Object.keys(medicalDetail).length && !activeArchives.length">
            <div class="space-y-2" style="padding:1rem 1.25rem;">
              <div style="font-weight:600;font-size:16px;margin-bottom:8px;">病例详情</div>
              <!-- 顶部只读信息块（无则占位） -->
              <div class="readonly-header">
                <div class="line"><span class="label">患者姓名：</span><span class="value">{{ itemCacheChatData?.realname || '-' }}</span></div>
                <div class="line"><span class="label">性别：</span><span class="value">{{ itemCacheChatData?.sexText || '-' }}</span></div>
                <div class="line"><span class="label">年龄：</span><span class="value">{{ itemCacheChatData?.age ? (itemCacheChatData.age + '岁') : '-' }}</span></div>
                <div class="line"><span class="label">就诊科室：</span><span class="value">{{ itemCacheChatData?.departmentName || '-' }}</span></div>
                <div class="line"><span class="label">就诊日期：</span><span class="value">{{ formatDate(medicalDetail?.visitDate) || '-' }}</span></div>
              </div>

              <!-- 可编辑字段，左侧标题，右侧文本框，失焦自动存档 -->
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('chiefComplaint')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('chiefComplaint')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('chiefComplaint') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.chiefComplaint" @blur="handleMedicalDetailBlur('chiefComplaint', $event)" :placeholder="'请输入' + getFieldLabel('chiefComplaint')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('presentIllness')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('presentIllness')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('presentIllness') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15 }" v-model="medicalDetail.presentIllness" @blur="handleMedicalDetailBlur('presentIllness', $event)" :placeholder="'请输入' + getFieldLabel('presentIllness')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('pastHistory')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('pastHistory')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('pastHistory') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.pastHistory" @blur="handleMedicalDetailBlur('pastHistory', $event)" :placeholder="'请输入' + getFieldLabel('pastHistory')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('allergyHistory')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('allergyHistory')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('allergyHistory') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.allergyHistory" @blur="handleMedicalDetailBlur('allergyHistory', $event)" :placeholder="'请输入' + getFieldLabel('allergyHistory')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('familyHistory')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('familyHistory')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('familyHistory') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.familyHistory" @blur="handleMedicalDetailBlur('familyHistory', $event)" :placeholder="'请输入' + getFieldLabel('familyHistory')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('marriageBearingHistory')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('marriageBearingHistory')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('marriageBearingHistory') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.marriageBearingHistory" @blur="handleMedicalDetailBlur('marriageBearingHistory', $event)" :placeholder="'请输入' + getFieldLabel('marriageBearingHistory')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('tobaccoAlcoholHistory')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('tobaccoAlcoholHistory')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('tobaccoAlcoholHistory') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.tobaccoAlcoholHistory" @blur="handleMedicalDetailBlur('tobaccoAlcoholHistory', $event)" :placeholder="'请输入' + getFieldLabel('tobaccoAlcoholHistory')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('vitalSigns')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('vitalSigns')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('vitalSigns') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.vitalSigns" @blur="handleMedicalDetailBlur('vitalSigns', $event)" :placeholder="'请输入' + getFieldLabel('vitalSigns')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('physicalExamination')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('physicalExamination')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('physicalExamination') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15 }" v-model="medicalDetail.physicalExamination" @blur="handleMedicalDetailBlur('physicalExamination', $event)" :placeholder="'请输入' + getFieldLabel('physicalExamination')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('primaryDiagnosis')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('primaryDiagnosis')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('primaryDiagnosis') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.primaryDiagnosis" @blur="handleMedicalDetailBlur('primaryDiagnosis', $event)" :placeholder="'请输入' + getFieldLabel('primaryDiagnosis')"/>
              </div></div>
              <div class="field-item" v-if="medicalDetail.hasOwnProperty('treatmentPlan')"><button class="copy-row-btn" title="复制本行" @click.stop="copyMedicalDetailField('treatmentPlan')"><i class="el-icon-document-copy"></i></button><div class="field-label">{{ getFieldLabel('treatmentPlan') }}：</div><div class="field-value">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="medicalDetail.treatmentPlan" @blur="handleMedicalDetailBlur('treatmentPlan', $event)" :placeholder="'请输入' + getFieldLabel('treatmentPlan')"/>
              </div></div>
            </div>
          </div>
          <div class="medical-record" v-if="activeArchives.length" @click="handleMedicalRecordClick">
            <div class="space-y-4">
              <!-- 患者基本信息（只读） -->
              <div class="readonly-header">
                <div class="line"><span class="label">患者姓名：</span><span class="value">{{ itemCacheChatData?.realname || '-' }}</span></div>
                <div class="line"><span class="label">性别：</span><span class="value">{{ itemCacheChatData?.sexText || '-' }}</span></div>
                <div class="line"><span class="label">年龄：</span><span class="value">{{ itemCacheChatData?.age ? (itemCacheChatData.age + '岁') : '-' }}</span></div>
                <div class="line"><span class="label">就诊科室：</span><span class="value">{{ itemCacheChatData?.departmentName || '-' }}</span></div>
                <div class="line"><span class="label">就诊日期：</span><span class="value">{{ formatDate(medicalDetail?.visitDate) || formatDate(new Date()) || '-' }}</span></div>
              </div>

              <!-- 病历字段显示区域 -->
              <div class="space-y-2">
                <div v-for="(item, index) in activeArchives" :key="index" class="field-container" :data-index="index">
                  <!-- 字段标题和内容组合显示 -->
                  <div class="field-row-layout">
                    <button class="copy-row-btn field-copy-btn" title="复制本行" @click.stop="copyArchiveField(item)">
                      <i class="el-icon-document-copy"></i>
                    </button>
                    <!-- 字段标题（固定宽度，不可编辑） -->
                    <div class="field-title flex-shrink-0">
                      <strong>{{getFieldChineseName(item)}}：</strong>
                    </div>
                    <!-- 字段内容区域 -->
                    <div class="flex-1 min-w-0">
                      <!-- 编辑模式 -->
                      <div v-if="item.isEdit" class="edit-mode">
                        <el-input
                          v-model="item.value"
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 15 }"
                          placeholder="请输入内容..."
                          @blur="handleInputBlur(item,index)"
                          @click.stop
                          :class="['edit-input', { 'locked-height': !!item.editHeight }]"
                          :style="item.editHeight ? { '--locked-edit-height': item.editHeight + 'px' } : null"
                          ref="editInput"
                        ></el-input>
                        <div class="edit-buttons">
                          <button
                            @mousedown="cancelEdit(item, index)"
                            class="cancel-edit-btn"
                          >取消编辑</button>
                        </div>
                      </div>

                      <!-- 显示模式 -->
                      <div v-else>
                        <!-- 检查是否有修改建议 -->
                        <div v-if="item.isEdit_newValue && item.isEdit_newValue!='未提供'" class="suggestion-mode">
                          <!-- 原始内容 - 红框 -->
                          <div class="original-content">
                            <div class="original-text-field" @click="editBtn(item,index,$event)" @click.stop>
                              <div class="content-wrapper">
                                <div class="whitespace-pre-wrap content-text" v-if="item.value">{{item.value}}</div>
                                <div class="placeholder-text" v-else>点击输入内容...</div>
                              </div>
                            </div>
                          </div>
                          <!-- 建议内容 - 绿色，点击可编辑 -->
                          <div class="suggested-content">
                            <!-- 建议编辑模式 -->
                            <div v-if="item.isEditingSuggestion" class="suggestion-edit-mode">
                              <el-input
                                v-model="item.isEdit_newValue"
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 15 }"
                                placeholder="请编辑建议内容..."
                                @blur="finishEditSuggestion(item, index)"
                                @click.stop
                                :class="['edit-suggestion-input', { 'locked-height': !!item.suggestionEditHeight }]"
                                :style="item.suggestionEditHeight ? { '--locked-edit-height': item.suggestionEditHeight + 'px' } : null"
                                ref="editSuggestionInput"
                              ></el-input>
                            </div>
                            <!-- 建议内容显示模式 -->
                            <span
                              v-else
                              class="suggested-text clickable-suggestion"
                              @click="editSuggestion(item,index,$event)"
                              @click.stop
                              title="点击编辑建议内容"
                            >
                              {{item.isEdit_newValue}}
                            </span>
                            <!-- 操作按钮放在右端 -->
                            <div class="suggestion-buttons">
                              <button class="accept-btn" @click="handleAccept(item,index)"><i class="el-icon-check"></i>接受</button>
                              <button class="reject-btn" @click="handleRefuse(item,index)"><i class="el-icon-close"></i>拒绝</button>
                            </div>
                          </div>
                        </div>

                        <!-- 正常显示模式 -->
                        <div v-else class="editable-field-content" @click="editBtn(item,index,$event)" @click.stop>
                          <div class="content-wrapper">
                            <div class="whitespace-pre-wrap content-text" v-if="item.value">{{item.value}}</div>
                            <div class="placeholder-text" v-else>点击输入内容...</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 空病历模板 - 显示完整的病历结构供医生填写 -->
          <div class="medical-detail" v-else-if="!(medicalDetail && Object.keys(medicalDetail).length) && !activeArchives.length && itemCacheChatData && !hasEmptyTemplateData()">
            <div class="space-y-2" style="padding:1rem 1.25rem;">
              <div style="font-weight:600;font-size:16px;margin-bottom:8px;">病历模板</div>

              <!-- 患者基本信息（只读） -->
              <div class="readonly-header">
                <div class="line"><span class="label">患者姓名：</span><span class="value">{{ itemCacheChatData?.realname || '-' }}</span></div>
                <div class="line"><span class="label">性别：</span><span class="value">{{ itemCacheChatData?.sexText || '-' }}</span></div>
                <div class="line"><span class="label">年龄：</span><span class="value">{{ itemCacheChatData?.age ? (itemCacheChatData.age + '岁') : '-' }}</span></div>
                <div class="line"><span class="label">就诊科室：</span><span class="value">{{ itemCacheChatData?.departmentName || '-' }}</span></div>
                <div class="line"><span class="label">就诊日期：</span><span class="value">{{ formatDate(new Date()) || '-' }}</span></div>
              </div>

              <!-- 可编辑的病历字段 -->
              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('chiefComplaint')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('chiefComplaint') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.chiefComplaint"
                    placeholder="患者主要症状和不适，如：头痛3天、发热2天等"
                    @input="handleEmptyFieldInput('chiefComplaint', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('presentIllness')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('presentIllness') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="emptyTemplateData.presentIllness"
                    placeholder="详细描述发病经过、症状变化、治疗情况等"
                    @input="handleEmptyFieldInput('presentIllness', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('pastHistory')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('pastHistory') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.pastHistory"
                    placeholder="既往疾病史、手术史、外伤史等"
                    @input="handleEmptyFieldInput('pastHistory', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('allergyHistory')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('allergyHistory') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.allergyHistory"
                    placeholder="药物过敏、食物过敏等过敏反应史"
                    @input="handleEmptyFieldInput('allergyHistory', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('familyHistory')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('familyHistory') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.familyHistory"
                    placeholder="家族遗传疾病、家族成员疾病史等"
                    @input="handleEmptyFieldInput('familyHistory', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('vitalSigns')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('vitalSigns') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.vitalSigns"
                    placeholder="体温、血压、心率、呼吸等生命体征数据"
                    @input="handleEmptyFieldInput('vitalSigns', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('physicalExamination')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('physicalExamination') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="emptyTemplateData.physicalExamination"
                    placeholder="体格检查结果、阳性体征、阴性体征等"
                    @input="handleEmptyFieldInput('physicalExamination', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('primaryDiagnosis')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('primaryDiagnosis') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.primaryDiagnosis"
                    placeholder="初步诊断、临床诊断、鉴别诊断等"
                    @input="handleEmptyFieldInput('primaryDiagnosis', $event)"
                  />
                </div>
              </div>

              <div class="field-item">
                <button class="copy-row-btn" title="复制本行" @click.stop="copyEmptyTemplateField('treatmentPlan')"><i class="el-icon-document-copy"></i></button>
                <div class="field-label">{{ getFieldLabel('treatmentPlan') }}：</div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="emptyTemplateData.treatmentPlan"
                    placeholder="治疗方案、用药建议、注意事项等"
                    @input="handleEmptyFieldInput('treatmentPlan', $event)"
                  />
                </div>
              </div>

              <!-- 提示信息 -->
              <div style="margin-top: 1rem; padding: 0.75rem; background-color: #f0f9ff; border: 1px solid #0ea5e9; border-radius: 0.375rem; font-size: 14px; color: #0369a1;">
                <i class="el-icon-info" style="margin-right: 0.5rem;"></i>
                提示：您可以手动填写上述字段，也可以先进行录音问诊，然后点击"引用"按钮自动填充相关内容。
              </div>
            </div>
          </div>

          <!-- 未选择患者时的提示 -->
          <div class="no-patient-selected" v-else-if="!itemCacheChatData || !itemCacheChatData.id">
            <div class="empty-state" style="padding-top:2rem; text-align: center;">
              <p style="font-size: 16px; color: #464646;">请先选择患者</p>
              <p style="color: #464646; font-size: 14px; margin-top: 8px;">从左侧患者列表中选择一个患者开始问诊</p>
            </div>
          </div>
        </div>

        <div v-if="type==3">
          <div class="dialogForm_read" v-if="tableData.length">
            <div v-for="(item, index) in tableData" :key="index" class="dialogForm_read_item">
              <div style="width: 100%; margin:0 5px 0 10px;font-weight:550">
                【{{item.createTime}}】
                <span class="editBtn" @click="handleDetails(item)">查看详情</span>
              </div>
            </div>
          </div>
          <div class="dialogForm_read" v-else></div>
        </div>
      </div>
      <div class="center" v-else>
        <div class="icoBox " style="margin-top:2rem">
          <div class="ico">
            <i class="el-icon-warning-outline"></i>
          </div>
        </div>
        <div class="text">请从左侧选择一位患者</div>
        <div class="text2">选择患者后查看病历详情</div>
      </div>
      <div class="bottom">
        <div class="btn">
          <el-tooltip
            v-if="false"
            class="item"
            :open-delay=800
            effect="dark"
            content="保存当前病历到历史记录"
            placement="top"
          >
            <button @click="saveArchives(false, true)" :disabled="isSavingArchives">
              <i class="el-icon-folder"></i>{{ isSavingArchives ? '保存中...' : '创建副本' }}
            </button>
          </el-tooltip>
          <el-popover placement="top" v-model="historyVisible" trigger="click" @show="loadHistoryListOnly">
            <div class="history-list">
              <template v-if="historyData && historyData.length > 0">
                <div
                  v-for="(item, index) in historyData"
                  :key="index"
                  class="history-item"
                  @click="selectHistoryArchive(item)"
                >
                  <div class="date">{{formatDate(item.visitDate)}}</div>
                  <div class="diagnosis">{{getHistoryDiagnosis(item)}}</div>
                </div>
              </template>
              <div v-else class="history-item-empty">
                <div class="empty-text">暂无病历历史</div>
              </div>
            </div>
            <template #reference>
              <el-tooltip
                class="item"
                :open-delay=800
                effect="dark"
                content="查看病历历史记录"
                placement="top"
              >
                <button>
                  <i class="el-icon-time"></i>操作记录
                </button>
              </el-tooltip>
            </template>
          </el-popover>
          <el-popover placement="top" v-model="visible">
            <div class="popover-content">
              <div class="title">
                <i class="el-icon-warning"></i>确认新建病历？
              </div>
              <div class="txt">此操作将清空现有病历内容，请谨慎操作！</div>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="clearMedicalRecordOnly">确定</el-button>
            </div>
            <template #reference>
              <el-tooltip
                class="item"
                :open-delay=800
                effect="dark"
                content="清空现有病历，请谨慎操作"
                placement="top"
              >
                <el-button
                  size="small"
                  class="del-btn-like-reject"
                >
                  <i class="el-icon-delete"></i>新建病历
                </el-button>
              </el-tooltip>
            </template>
          </el-popover>
<!--          <el-tooltip-->
<!--            class="item"-->
<!--            :open-delay=800-->
<!--            effect="dark"-->
<!--            content="结束当前会话"-->
<!--            placement="top"-->
<!--          >-->
<!--            <button @click="confirmEndConversation">-->
<!--              <i class="el-icon-switch-button"></i>结束会话-->
<!--            </button>-->
<!--          </el-tooltip>-->
        </div>
      </div>

      <!-- 全部接受和全部拒绝按钮 - 固定在右下角 -->
      <div v-if="hasAiSuggestions" class="ai-suggestion-buttons-fixed">
        <el-tooltip
          class="item"
          :open-delay=800
          effect="dark"
          content="接受所有AI建议的修改"
          placement="top"
        >
          <button @click="handleAcceptAll" class="accept-all-btn">
            <i class="el-icon-check"></i>全部接受
          </button>
        </el-tooltip>
        <el-tooltip
          class="item"
          :open-delay=800
          effect="dark"
          content="拒绝所有AI建议的修改"
          placement="top"
        >
          <button @click="handleRejectAll" class="reject-all-btn">
            <i class="el-icon-close"></i>全部拒绝
          </button>
        </el-tooltip>
      </div>
    </div>

    <!-- 中右面板分隔符 -->
    <div
      class="panel-divider"
      @mousedown="startResize('middle')"
      :style="{ right: rightPanelWidth + 'px' }"
    >
      <div class="divider-handle"></div>
    </div>
    <!-- 右侧医生与机器人零时对话 -->
    <div
      class="chatBox_dom"
      :style="{
      width: rightPanelWidth - 10 + 'px'
    }"
    >
      <!-- 录音 -->
              <div class="soundRecording">
          <SoundRecording
              ref="soundRecording"
              :medmstrId="itemCacheChatData?.id"
            :chatGroup="getChatGroupByView()"
            @uploadRecording="uploadRecording"
            @handleShibie="handleShibie"
            @selectTemplate="handleSelectTemplate"
            @recordingStateChange="handleRecordingStateChange"
            @switchToConversation="handleSwitchToConversation"
            @startNewConversation="handleStartNewConversation"
            @selectRecordingHistory="handleSelectRecordingHistory"
            @loadRecordingHistory="handleLoadRecordingHistory"
          />
      </div>
      <ChatBoxDoctor
        ref="chatBoxDoctor"
        :chatData="chatData_doctor"
        :selectedTemplate="selectedTemplateName"
        :recordingState="recordingState"
        :patientName="currentPatientName"
        :currentChatId="itemCacheChatData?.chatId"
        :currentMedmstrId="itemCacheChatData?.id"
        @sendBtn="sendBtn_doctor"
        @deleteBtn="deleteBtn"
        @createBtn="createBtn"
        @extractFullContent="extractFullContent"
        @updateBtn="updateBtn"
        @createByOneBtn="createByOneBtn"
        @batchQuoteAiReplies="handleBatchQuoteAiReplies"
        @retryRecording="retryFailedRecording"
      ></ChatBoxDoctor>
    </div>
    <!-- 语音转化弹窗 -->
    <!--    <el-dialog title="编辑内容并引用" :visible.sync="dialogFormVisible" width="35%">-->
    <!--      <div class="editBox">-->
    <!--        <p>编辑内容：</p>-->
    <!--        <el-input-->
    <!--            type="textarea"-->
    <!--            :rows="10"-->
    <!--            placeholder="请输入内容"-->
    <!--            v-model="audioMessage"-->
    <!--            style="width: 100%"-->
    <!--        ></el-input>-->
    <!--      </div>-->
    <!--      <div slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>-->
    <!--        <el-button type="primary" @click="handleSend" size="small" class="sub">确定并引用到聊天</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <!-- 语音转化弹窗 -->
    <el-dialog
      title="录音内容"
      :visible.sync="dialogFormVisible"
      width="45%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :append-to-body="true"
      :modal="false"
      custom-class="recording-dialog"
      @close="clearAudioPath"
    >
      <!-- 音频播放控件和重试按钮 -->
      <div v-if="currentAudioFilePath" class="audio-section" style="margin-bottom: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 8px; display: flex; align-items: center; gap: 12px;">
        <audio :src="currentAudioFilePath" controls style="flex: 1;"></audio>
        <el-button
          type="warning"
          size="small"
          icon="el-icon-refresh"
          @click="handleRetryRecording"
          :loading="audioRetryLoading"
        >
          重新上传音频
        </el-button>
      </div>

      <div class="editBox">
        <el-input
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="extractedMessage"
          style="width: 100%; font-size: 19.5px; font-weight: bold;"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSend" class="sub">确定并引用到病历</el-button>
        <el-button type="success" @click="handleAcceptAllAndSubmit" :loading="hisSubmitLoading" class="accept-all-submit-btn">
          <i class="el-icon-check"></i>全部接受并提交HIS
        </el-button>
      </div>
    </el-dialog>
    <!-- his -->
    <el-dialog title="确认提交到HIS系统" :visible.sync="hisSub" width="30%" custom-class="his-dialog">
      <div class="hisDia">
        <p>您确定要将当前病历提交到HIS系统吗？</p>
        <span>提交后将无法撤销，请确认内容已核对无误。</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hisSub = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmHisSubmit" size="small" :loading="hisSubmitLoading">确认提交</el-button>
      </span>
    </el-dialog>

    <!-- 快速提交进度模态框 -->
    <el-dialog
      title="正在处理..."
      :visible.sync="showQuickSubmitModal"
      width="40%"
      custom-class="quick-submit-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="quick-submit-content">
        <div class="progress-section">
          <div class="progress-text">{{ submitProgressText }}</div>
          <el-progress
            :percentage="submitProgress"
            :status="submitProgress === 100 ? 'success' : ''"
            :stroke-width="20"
            :show-text="true"
          ></el-progress>
        </div>

        <div class="steps-list">
          <div
            v-for="(step, index) in submitSteps"
            :key="index"
            class="step-item"
            :class="{
              'step-active': index === currentSubmitStep,
              'step-completed': index < currentSubmitStep,
              'step-waiting': index > currentSubmitStep
            }"
          >
            <div class="step-icon">
              <i v-if="index < currentSubmitStep" class="el-icon-check step-success"></i>
              <i v-else-if="index === currentSubmitStep" class="el-icon-loading step-loading"></i>
              <i v-else class="el-icon-more step-waiting-icon"></i>
            </div>
            <div class="step-content">
              <div class="step-title">{{ step.title }}</div>
              <div class="step-desc">{{ step.description }}</div>
            </div>
          </div>
        </div>

        <div v-if="submitError" class="error-message">
          <i class="el-icon-warning-outline"></i>
          {{ submitError }}
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="submitError" @click="showQuickSubmitModal = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 病历历史确认弹窗（与住院病历保持一致：无全屏遮罩，作为悬浮窗显示） -->
    <el-dialog
      title="重新启用历史病历"
      :visible.sync="medicalHistoryConfirmVisible"
      width="80%"
      custom-class="medical-history-dialog"
      :modal="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="onMedicalHistoryDialogOpen"
    >
      <div class="history-confirm-dialog">
        <div class="dialog-content">
          <!-- 左侧：病历历史列表 -->
          <div class="history-list-panel">
            <h4>病历历史记录</h4>
            <div class="history-scroll-list">
              <div
                v-for="(item, index) in historyData"
                :key="index"
                class="history-item-in-dialog"
                :class="{ active: selectedHistoryItem && selectedHistoryItem.id === item.id }"
                @click="switchToMedicalHistory(item)"
              >
                <div class="date">{{formatDate(item.visitDate)}}</div>
                <div class="preview">{{getHistoryDiagnosis(item)}}</div>
                <div class="source">来源：{{item.source || '未知'}}</div>
              </div>
            </div>
          </div>

          <!-- 右侧：病历内容显示 -->
          <div class="history-content-panel">
            <h4>病历内容</h4>
            <div class="content-display" v-if="selectedHistoryItem">
              <div class="medical-record-content" v-if="historyDialogActiveArchives && historyDialogActiveArchives.length > 0">
                <div class="field-item" v-for="(field, index) in historyDialogActiveArchives" :key="index">
                  <div class="field-label">{{ field.label }}：</div>
                  <div class="field-value">{{ field.value || '-' }}</div>
                </div>
              </div>
              <div class="medical-record-content" v-else>
                <div class="no-selection">正在加载病例详情...</div>
              </div>
            </div>
            <div class="content-display" v-else>
              <div class="no-selection">请从左侧选择病历历史记录</div>
            </div>
          </div>
        </div>

        <div class="confirm-action">
          <p><i class="el-icon-warning"></i> 重新启用此病历记录将替换当前正在编辑的病历内容，是否确认？</p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUseMedicalHistory" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmUseMedicalHistory" size="small">重新启用此历史病历</el-button>
      </span>
    </el-dialog>
  <!-- 会话历史弹窗 -->
  <el-dialog title="医生-AI问答记录" :visible.sync="conversationModalVisible" width="80%" custom-class="conversation-dialog">
    <div style="display:flex;gap:12px;min-height:420px;">
      <!-- 左侧会话列表 -->
      <div style="width:280px;border-right:1px solid #eee;overflow:auto;">
        <div v-for="c in conversationList" :key="c.id" @click="loadConversationDetail(c.id)" style="padding:8px 10px;cursor:pointer;border-bottom:1px solid #f5f5f5;">
          <div style="font-weight:600;">{{ c.patientName }}（{{ c.medmstrId }}）</div>
          <div style="color:#464646;font-size:12px;">{{ c.sessionTime }}</div>
          <div style="color:#464646;font-size:12px;">消息：{{ c.messageCount }} 时长：{{ c.durationMinutes }}分</div>
          <div style="color:#464646;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ c.summary }}</div>
        </div>
      </div>
      <!-- 右侧会话内容 -->
      <div style="flex:1;overflow:auto;padding:8px 10px;">
        <div v-if="!conversationMessages || conversationMessages.length===0" style="color:#464646;">暂无会话内容</div>
        <div v-for="m in conversationMessages" :key="m.id" style="margin-bottom:10px;">
          <div :style="{color: m.senderType==='doctor' ? '#1a1a1a' : '#0b79d0', fontWeight: 600}">{{ m.senderType==='doctor' ? '医生' : 'AI' }} · {{ formatTime(m.createTime) }}</div>
          <div style="white-space:pre-wrap;">{{ m.content }}</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="conversationModalVisible=false">关 闭</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import consultationControlClass from "@/components/consultationControl_class";
import ChatBox from "@/components/chatBox";
import ChatBoxDoctor from "@/components/chatBox_doctor";
import { getAi_Reference,postAi_Record } from "@/services/newcall"
import { request } from "@/utils/request";



import {
  updateApi,
  sendMessageLy, // 新的发送消息接口
  createConversationLy // 新的创建会话接口
} from "@/services/conversation/index";
import ElTable from "@/components/elTable/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
import SoundRecording from "@/components/soundRecording/index.vue";
import { BASE_URL } from "@/config";

import { commonRecord } from './data.js';
import { saveFailedRecording, cleanExpiredRecordings } from "@/utils/recordingStorage";

const CURRENT_PATIENT_DEPARTMENT_ID_KEY = 'currentPatientDepartmentId';


export default {
  components: {
    ElTable,
    StoreToString,
    consultationControlClass,
    ChatBox,
    ChatBoxDoctor,
    SoundRecording
  },
  created() {
    // 移除重复的getListData调用，由子组件consultationControlClass负责加载患者列表
  },
  mounted() {
    // 添加全局鼠标事件监听器
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  },
  beforeDestroy() {
    // 移除事件监听器
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
  },

  data() {
    return {
      hisSub: false,
      visible: false,
      historyVisible: false,
      medicalHistoryConfirmVisible: false, // 病历历史确认弹窗
      chatHistoryConfirmVisible: false, // 聊天会话历史确认弹窗
      selectedHistoryItem: null, // 当前选中的历史记录
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        admin_id: null
      },
      dialogForm: {
        type: "",
        message: []
      },

      tableData: [], //患者病历历史

      arrayByIdToNameStr,
      cycleList: [],
      gzhList: [],
      loading: false,
      loading_btn: false,
      dialogFormVisible: false,
      inpitTypeName: "",

      dialogFormVisible_cycle: false,
      classData: [],
      chatData: [],
      activeArchives: [],
      audioURL: "",
      itemCacheChatData: {},
      currentDepartmentId: "",
      type: 1, //  1.聊天记录 2.历史病历

      /* 机器人与医生对话 */
      chatData_doctor: [],
      audioMessage: "", //录音内容
      extractedMessage: "", //提取内容
      selectedTemplateName: "通用模板", // 默认选择的模板
      extractLoading: false, // 重新提取内容加载状态

      // 面板宽度控制
      leftPanelWidth: 400, // 左侧面板默认宽度
      rightPanelWidth: 400, // 右侧面板默认宽度
      isResizing: false, // 是否正在调整大小
      resizeType: "", // 调整类型 ('left' 或 'middle')
      startX: 0, // 鼠标开始位置
      startLeftWidth: 0, // 开始时左侧宽度
      startRightWidth: 0, // 开始时右侧宽度

      // 控制取消编辑时不触发保存
      isCancelling: false,

      // 病历历史数据
      historyData: [],

      // 录音状态
      recordingState: {
        isRecording: false,
        duration: 0
      },

      // 标记是否来自录音
      isFromRecording: false,

      // 查看按钮状态：true=查看病历，false=查看预问诊对话
      isViewingMedicalRecord: true,

      // 重置病历对话框
      resetVisible: false,

      // 病历字段中文映射（保留作为后备）
      fieldNameMapping: commonRecord,
      // 字段配置缓存（从 /ly/archive/fields/template 接口获取）
      fieldConfig: {}, // { key: { label, key, ... } }
      // 新增：病例详情（仅缓存/保存时使用，不参与渲染）
      medicalDetail: null,

      // 存储 medical-detail 区域的原始值，用于检查文本是否改变
      medicalDetailOriginalValues: {},

      // 弹层独立的数据变量（用于操作记录弹层，与主病历区域隔离）
      historyDialogMedicalDetail: {},
      historyDialogActiveArchives: [],
      historyDialogMedicalDetailOriginalValues: {},

      // 会话列表/详情（新接口）
      conversationList: [],
      conversationModalVisible: false,
      conversationMessages: [],
      selectedConversationId: null,

      // 空模板字段数据
      emptyTemplateData: {
        chiefComplaint: '',
        presentIllness: '',
        pastHistory: '',
        allergyHistory: '',
        familyHistory: '',
        marriageBearingHistory: '',
        tobaccoAlcoholHistory: '',
        vitalSigns: '',
        physicalExamination: '',
        primaryDiagnosis: '',
        treatmentPlan: ''
      },
      // 结束会话相关
      isConversationEnded: false,
      saveDebounceTimer: null,

      // HIS提交相关
      hisSubmitLoading: false,

      // 病历保存防重复调用
      isSavingArchives: false,

      // 快速提交进度相关
      showQuickSubmitModal: false,
      submitProgress: 0,
      submitProgressText: '',
      currentSubmitStep: 0,
      submitError: '',
      submitSteps: [
        { title: '处理录音内容', description: '正在将录音内容引用到病历并生成AI建议...' },
        { title: '发送消息', description: '正在发送消息到聊天记录...' },
        { title: '全部接受AI建议', description: '正在接受所有AI建议的内容...' },
        { title: '保存病历', description: '正在保存病历到数据库...' },
        { title: '提交HIS系统', description: '正在将病历提交到HIS系统...' }
      ],

      // 录音音频路径和重试状态
      currentAudioFilePath: '',
      audioRetryLoading: false
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"]),
    // 检测是否有AI建议
    hasAiSuggestions() {
      return Array.isArray(this.activeArchives) && this.activeArchives.some(item =>
        item.isEdit_newValue && item.isEdit_newValue !== '未提供' && item.isEdit_newValue !== null
      );
    },
    // 获取患者名称，支持多个可能的字段名
    currentPatientName() {
      if (!this.itemCacheChatData) return '';
      return this.itemCacheChatData.realname ||
             this.itemCacheChatData.name ||
             this.itemCacheChatData.patientName ||
             this.itemCacheChatData.username ||
             '';
    }
  },
  watch: {
    // 当左侧患者列表被折叠为空或刷新后无数据时，恢复右侧为空视图
    classData: {
      deep: false,
      handler(newVal) {
        if (!newVal || (Array.isArray(newVal) && newVal.length === 0)) {
          this.clearRightPanelState();
        }
      }
    }
  },
  methods: {
    async copyText(text, successMsg = "已复制") {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success(successMsg);
      } catch (e) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        this.$message.success(successMsg);
      }
    },
    buildCopyLine(label, value) {
      return `${label}：${(value || "").toString().trim()}`;
    },
    copyArchiveField(item) {
      const label = this.getFieldChineseName(item);
      const value = (item && item.value) || "";
      if (!value.toString().trim()) {
        this.$message.warning("当前字段为空，未复制");
        return;
      }
      this.copyText(this.buildCopyLine(label, value), "已复制当前行");
    },
    copyMedicalDetailField(fieldKey) {
      if (!this.medicalDetail) {
        this.$message.warning("当前字段为空，未复制");
        return;
      }
      const label = this.getFieldLabel(fieldKey);
      const value = this.medicalDetail[fieldKey] || "";
      if (!value.toString().trim()) {
        this.$message.warning("当前字段为空，未复制");
        return;
      }
      this.copyText(this.buildCopyLine(label, value), "已复制当前行");
    },
    copyEmptyTemplateField(fieldKey) {
      const label = this.getFieldLabel(fieldKey);
      const value = this.emptyTemplateData[fieldKey] || "";
      if (!value.toString().trim()) {
        this.$message.warning("当前字段为空，未复制");
        return;
      }
      this.copyText(this.buildCopyLine(label, value), "已复制当前行");
    },
    collectCurrentMedicalLines() {
      const lines = [];
      if (Array.isArray(this.activeArchives) && this.activeArchives.length > 0) {
        this.activeArchives.forEach((item) => {
          const label = this.getFieldChineseName(item);
          const value = ((item && item.value) || "").toString().trim();
          if (value) lines.push(this.buildCopyLine(label, value));
        });
        return lines;
      }

      if (this.medicalDetail && Object.keys(this.medicalDetail).length > 0) {
        Object.keys(this.medicalDetail).forEach((key) => {
          if (["visitDate", "medmstrId", "consultationId"].includes(key)) return;
          const value = (this.medicalDetail[key] || "").toString().trim();
          if (!value) return;
          lines.push(this.buildCopyLine(this.getFieldLabel(key), value));
        });
        return lines;
      }

      Object.keys(this.emptyTemplateData || {}).forEach((key) => {
        const value = (this.emptyTemplateData[key] || "").toString().trim();
        if (value) lines.push(this.buildCopyLine(this.getFieldLabel(key), value));
      });
      return lines;
    },
    async copyCurrentPageContent() {
      const lines = this.collectCurrentMedicalLines();
      if (!lines.length) {
        this.$message.warning("当前页面暂无可复制内容");
        return;
      }
      await this.copyText(lines.join("\n"), "已复制本页内容");
    },
    /* 工具：对象详情 -> 标准字段数组 */
    normalizeDetailToArchives(detailObj = {}) {
      // 优先使用字段配置，如果没有则使用 detailObj 中的字段
      const excludeKeys = ['visitDate', 'medmstrId', 'consultationId'];

      // 如果有字段配置，使用字段配置的顺序
      if (Object.keys(this.fieldConfig).length > 0) {
        return Object.values(this.fieldConfig)
          .filter(f => detailObj.hasOwnProperty(f.key) && !excludeKeys.includes(f.key))
          .map(f => ({
            key: f.key,
            label: f.label,
            value: detailObj[f.key] || '',
            originalValue: detailObj[f.key] || '' // 记录原始值
          }));
      }

      // 后备：如果没有字段配置，使用 detailObj 中的所有字段
      return Object.keys(detailObj)
        .filter(key => !excludeKeys.includes(key))
        .map(key => ({
          key: key,
          label: this.getFieldLabel(key),
          value: detailObj[key] || '',
          originalValue: detailObj[key] || ''
        }));
    },

    /* 工具：合并AI建议 -> activeArchives */
    mergeArchivesSuggestions(suggestionFields = []) {
      if (!Array.isArray(this.activeArchives) || this.activeArchives.length === 0) {
        // 若当前还没有activeArchives，则先创建标准空字段
        this.activeArchives = this.createStandardEmptyArchives();
      }

      // 创建字段映射，支持多种字段名称格式
      const map = new Map();
      this.activeArchives.forEach(item => {
        // 支持通过title或key进行映射
        map.set(item.title, item);
        if (item.key) map.set(item.key, item);
        // 也支持通过映射后的名称匹配
        const mappedKey = this.getFieldMapping(item.key);
        if (mappedKey !== item.key) {
          map.set(mappedKey, item);
        }
      });

      // 处理AI建议
      suggestionFields.forEach(sf => {
        const fieldName = sf.key || sf.fieldName || sf.title;
        const suggestedValue = sf.suggestedValue || sf.value || sf.content || '';
        const fieldLabel = sf.label || fieldName;

        console.log('处理AI建议字段:', fieldName, '标签:', fieldLabel, '建议值:', suggestedValue);

        // 尝试多种方式匹配字段
        let item = map.get(fieldName);
        if (!item) {
          // 尝试通过字段名称映射匹配
          const mappedName = this.getFieldMapping(fieldName);
          item = map.get(mappedName);
        }

        if (item) {
          this.$set(item, 'isEdit_newValue', suggestedValue);
          console.log(`已为字段 ${item.title} 添加AI建议:`, suggestedValue);
        } else {
          // 如果找不到匹配的字段，创建一个新的字段，使用API返回的label作为title
          console.warn(`未找到匹配的字段: ${fieldName}，创建新字段`);
          this.activeArchives.push({
            key: fieldName,
            title: fieldLabel, // 使用API返回的label作为显示名称
            value: '',
            isEdit: false,
            originalValue: '',
            isEdit_newValue: suggestedValue
          });
        }
      });

      // 触发视图更新
      this.$forceUpdate();
    },
    // 提供给子组件的切换患者前置校验
    // allowSwitchPatient() {
    //   // 未选择会话或已结束，允许切换
    //   if (!this.itemCacheChatData?.chatId) return true;
    //   return this.isConversationEnded === true;
    // },
    // 清空右侧面板的当前选择和内容，恢复为空视图
    getCurrentDepartmentId() {
      return (
        this.currentDepartmentId ||
        this.itemCacheChatData?.departmentId ||
        localStorage.getItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY) ||
        ''
      );
    },
    clearRightPanelState() {
      this.itemCacheChatData = {};
      this.currentDepartmentId = "";
      localStorage.removeItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY);
      this.type = 1; // 切回到默认空态（聊天/空白）
      this.activeArchives = [];
      this.medicalDetail = null;
      this.historyData = [];
      this.chatData = [];
      this.chatData_doctor = [];
      this.selectedHistoryItem = null;

      // 重置空模板数据
      this.emptyTemplateData = {
        chiefComplaint: '',
        presentIllness: '',
        pastHistory: '',
        allergyHistory: '',
        familyHistory: '',
        marriageBearingHistory: '',
        tobaccoAlcoholHistory: '',
        vitalSigns: '',
        physicalExamination: '',
        primaryDiagnosis: '',
        treatmentPlan: ''
      };
    },


    // 创建空字段并填充AI建议
    createEmptyArchivesWithSuggestions(suggestionFields) {
      // 先创建标准的空字段
      this.activeArchives = this.createStandardEmptyArchives();

      if (!suggestionFields || suggestionFields.length === 0) {
        console.log('没有AI建议，只创建空字段');
        return;
      }

      // 创建字段映射
      const map = new Map();
      this.activeArchives.forEach(item => {
        map.set(item.key, item);
        map.set(item.title, item);
      });

      // 处理AI建议，设置为建议模式
      suggestionFields.forEach(suggestion => {
        const fieldName = suggestion.key;
        const suggestedValue = suggestion.suggestedValue || suggestion.value || suggestion.content || '';
        const fieldLabel = suggestion.label || fieldName;

        console.log('处理AI建议字段:', fieldName, '标签:', fieldLabel, '建议值:', suggestedValue);

        // 查找匹配的字段
        let item = map.get(fieldName);
        if (!item) {
          // 尝试通过映射匹配
          const mappedName = this.getFieldMapping(fieldName);
          item = map.get(mappedName);
        }

        if (item) {
          // 设置为建议模式：原始值为空，建议值在isEdit_newValue中
          item.value = '';
          item.originalValue = '';
          item.isEdit_newValue = suggestedValue;
          console.log(`已为字段 ${item.title} 设置AI建议:`, suggestedValue);
        } else {
          console.warn(`未找到匹配的字段: ${fieldName}`);
        }
      });

      console.log('已创建病历字段并设置AI建议:', this.activeArchives);
    },

    // 创建标准的空字段（使用字段配置）
    createStandardEmptyArchives() {
      // 优先使用字段配置
      if (Object.keys(this.fieldConfig).length > 0) {
        return Object.values(this.fieldConfig).map(f => ({
          key: f.key,
          title: f.label,
          label: f.label,
          value: '',
          isEdit: false,
          originalValue: '',
          isEdit_newValue: null
        }));
      }

      // 后备：如果没有字段配置，返回空数组（不应该出现这种情况，因为应该在 loadFieldTemplate 中初始化）
      console.warn('createStandardEmptyArchives: 字段配置未初始化，返回空数组');
      return [];
    },

    // 处理空模板字段输入
    handleEmptyFieldInput(fieldName, value) {
      // 更新空模板数据
      this.emptyTemplateData[fieldName] = value;

      // 如果当前在空模板状态，且用户开始输入内容，则转换为动态模板
      const isInEmptyTemplate = !(this.medicalDetail && Object.keys(this.medicalDetail).length) && !this.activeArchives.length && this.itemCacheChatData;

      if (isInEmptyTemplate && value && value.trim()) {
        // 使用 $nextTick 确保DOM更新完成后再转换
        this.$nextTick(() => {
          // 创建动态模板并填充所有已有内容
          this.activeArchives = this.createStandardEmptyArchives();

          // 填充所有已有内容的字段
          Object.keys(this.emptyTemplateData).forEach(key => {
            if (this.emptyTemplateData[key] && this.emptyTemplateData[key].trim()) {
              const fieldIndex = this.activeArchives.findIndex(field => this.getFieldMapping(key) === field.title);
              if (fieldIndex !== -1) {
                this.activeArchives[fieldIndex].value = this.emptyTemplateData[key];
                this.activeArchives[fieldIndex].originalValue = this.emptyTemplateData[key];
              }
            }
          });

          // 清空空模板数据，避免重复显示
          this.emptyTemplateData = {
            chiefComplaint: '',
            presentIllness: '',
            pastHistory: '',
            allergyHistory: '',
            familyHistory: '',
            vitalSigns: '',
            physicalExamination: '',
            primaryDiagnosis: '',
            treatmentPlan: ''
          };

          console.log('已从空模板转换为动态模板，并填充所有字段');
        });
      }
    },

    // 字段名称映射（用于显示，优先使用字段配置）
    getFieldMapping(fieldName) {
      // 如果是字段key，返回中文标签
      if (this.fieldConfig[fieldName] && this.fieldConfig[fieldName].label) {
        return this.fieldConfig[fieldName].label;
      }

      // 如果是中文，尝试反向查找（保留原有逻辑作为后备）
      if (this.fieldNameMapping && this.fieldNameMapping[fieldName]) {
        return this.fieldNameMapping[fieldName];
      }

      // 后备映射（当 fieldConfig 和 fieldNameMapping 都不存在时使用，作为最后的兜底方案）
      // 注意：正常情况下应该使用 fieldConfig，此映射仅作为边缘情况的兜底
      const backupMapping = {
        主诉: 'chiefComplaint',
        现病史: 'presentIllness',
        既往史: 'pastHistory',
        过敏史: 'allergyHistory',
        家族史: 'familyHistory',
        婚育史: 'marriageBearingHistory',
        烟酒史: 'tobaccoAlcoholHistory',
        生命体征: 'vitalSigns',
        体格检查: 'physicalExamination',
        诊断: 'primaryDiagnosis',
        治疗计划: 'treatmentPlan'
      };
      return backupMapping[fieldName] || fieldName;
    },

    // 数据库字段映射
    // 接口返回的 key 就是数据库字段名，所以直接返回即可
    getDbFieldMapping(fieldName) {
      // 如果字段配置中存在，直接使用 key（key 就是数据库字段名）
      if (this.fieldConfig[fieldName]) {
        return this.fieldConfig[fieldName].key;
      }
      // 如果没有字段配置，直接返回 fieldName（通常它本身就是数据库字段名）
      return fieldName;
    },

    // 检查空模板是否有数据
    hasEmptyTemplateData() {
      return Object.values(this.emptyTemplateData).some(value => value && value.trim());
    },

    // 获取字段标签（优先使用字段配置，否则使用后备映射）
    getFieldLabel(key) {
      if (this.fieldConfig[key] && this.fieldConfig[key].label) {
        return this.fieldConfig[key].label;
      }
      // 后备：使用原有的字段映射
      if (this.fieldNameMapping && this.fieldNameMapping[key]) {
        return this.fieldNameMapping[key];
      }
      return key;
    },

    // 检查字段是否存在配置中
    hasFieldConfig(key) {
      return !!this.fieldConfig[key];
    },

    // 获取所有字段配置
    getAllFieldConfig() {
      return Object.values(this.fieldConfig);
    },
    // 弹窗打开时，自动展示第一条病历详情
    async onMedicalHistoryDialogOpen() {
      if (this.historyData && this.historyData.length > 0) {
        // 优先使用已选中的项目，否则使用第一条
        const targetItem = this.selectedHistoryItem || this.historyData[0];
        this.selectedHistoryItem = targetItem;
        if (targetItem && targetItem.id) {
          // 传入 true 表示弹层调用，更新弹层变量
          await this.handleViewMedicalDetail(targetItem.id, true);
        }
      }
    },
    // 左侧点击病历记录，拉取病例详情
    // isDialog: true 表示弹层调用，更新弹层变量；false 表示主区域调用，更新主区域变量
    async handleViewMedicalDetail(recordId, isDialog = false) {
      try {
        const resp = await request({
          url: '/ly/archive/history/detail',
          method: 'POST',
          data: {
            recordId,
            departmentId: this.getCurrentDepartmentId()
          }

        });
        if (resp && resp.success) {
          // 兼容两种返回：优先使用 fields；否则用 medicalDetail normalize
          const result = resp.result || {};
          const medicalDetailData = result.medicalDetail || result || {};

          // 初始化原始值（只初始化后端返回的字段）
          const medicalDetailOriginalValues = {};
          // 排除非字段属性
          const excludeKeys = ['visitDate', 'medmstrId', 'consultationId'];
          Object.keys(medicalDetailData).forEach(key => {
            if (!excludeKeys.includes(key)) {
              medicalDetailOriginalValues[key] = medicalDetailData[key] || '';
            }
          });

          let activeArchivesData = [];
          // 确保 fields 字段存在（后端应该始终返回，即使为空数组）
          const fields = Array.isArray(result.fields) ? result.fields : [];

          if (fields.length > 0) {
            // 更新字段配置缓存（历史详情接口也可能返回字段配置）
            fields.forEach(f => {
              if (!this.fieldConfig[f.key]) {
                this.fieldConfig[f.key] = {
                  label: f.label,
                  key: f.key
                };
              }
            });

            // 转为activeArchives：fields -> {key,label,value}
            activeArchivesData = fields.map(f => ({
              key: f.key,
              label: f.label,
              value: f.value || '',
              originalValue: f.value || '' // 记录原始值
            }));
          } else {
            // fields 为空数组时的降级处理
            // 如果 fieldConfig 有缓存，使用缓存构建空的 activeArchives（用于显示字段结构）
            if (Object.keys(this.fieldConfig).length > 0) {
              activeArchivesData = Object.values(this.fieldConfig).map(f => ({
                key: f.key,
                label: f.label,
                value: '',
                originalValue: ''
              }));
            } else {
              // 如果 fieldConfig 也没有，说明这是第一次加载且没有病例内容
              // 返回空数组，让前端显示空模板（空模板会通过其他方式加载字段配置）
              console.warn('字段配置为空，且历史详情接口返回的 fields 为空，将显示空模板');
              activeArchivesData = [];
            }
          }

          // 历史详情接口返回的数据应该是有值的，不需要设置默认值
          // 根据 isDialog 参数决定更新哪个变量
          if (isDialog) {
            // 弹层调用：更新弹层独立变量
            this.historyDialogMedicalDetail = medicalDetailData;
            this.historyDialogActiveArchives = activeArchivesData;
            this.historyDialogMedicalDetailOriginalValues = medicalDetailOriginalValues;
          } else {
            // 主区域调用：更新主区域变量
            this.medicalDetail = medicalDetailData;
            this.activeArchives = activeArchivesData;
            this.medicalDetailOriginalValues = medicalDetailOriginalValues;
          }
        } else {
          // 根据 isDialog 参数决定清空哪个变量
          if (isDialog) {
            this.historyDialogMedicalDetail = {};
            this.historyDialogActiveArchives = [];
            this.historyDialogMedicalDetailOriginalValues = {};
          } else {
            this.medicalDetail = {};
            this.activeArchives = [];
            this.medicalDetailOriginalValues = {};
          }
        }
      } catch (e) {
        // 根据 isDialog 参数决定清空哪个变量
        if (isDialog) {
          this.historyDialogMedicalDetail = {};
          this.historyDialogActiveArchives = [];
        } else {
          this.medicalDetail = {};
          this.activeArchives = [];
        }
      }
    },
    // 打开会话历史弹窗
    async openConversationHistory() {
      await this.fetchConversationList();
      this.conversationModalVisible = true;
      if (this.conversationList.length > 0) {
        this.loadConversationDetail(this.conversationList[0].id);
      }
    },
    // 拉取会话列表
    async fetchConversationList() {
      try {
        const doctor = localStorage.getItem('userId') || this.userInfo?.id;

        // 获取 visitNum：优先从 itemCacheChatData，其次从 classData 中查找，最后从 localStorage
        let visitNum = this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber;
        if (!visitNum && this.itemCacheChatData?.id) {
          // 从 classData 中查找对应患者
          const patient = this.classData.find(item => item.id === this.itemCacheChatData.id);
          if (patient) {
            visitNum = patient.visitNum || patient.visitNumber;
          }
        }
        if (!visitNum) {
          visitNum = localStorage.getItem('visitNum') || '';
        }

        const resp = await request({
          url: '/ly/conversation/list',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData?.id || '',
            professionalId: doctor,
            pageNum: 1,
            pageSize: 100,
            visitNum: visitNum
          }
        });
        if (resp && resp.success && Array.isArray(resp.result)) {
          this.conversationList = resp.result;
        } else {
          this.conversationList = [];
        }
      } catch (e) {
        this.conversationList = [];
      }
    },
    // 拉取会话详情
    async loadConversationDetail(conversationId) {
      this.selectedConversationId = conversationId;
      try {
        const resp = await request({
          url: '/ly/conversation/detail',
          method: 'POST',
          data: {
            conversationId
          }
        });
        if (resp && resp.success && resp.result) {
          this.conversationMessages = resp.result.conversationData || [];
        } else {
          this.conversationMessages = [];
        }
      } catch (e) {
        this.conversationMessages = [];
      }
    },
    // 获取字段中文名称  xhduan  中文映射（优先使用字段配置）
    getFieldChineseName(item) {
      // 优先使用已有的中文title（我们创建的字段使用title）
      if (item.title && typeof item.title === 'string' && /[\u4e00-\u9fa5]/.test(item.title)) {
        return item.title;
      }

      // 优先使用已有的中文label
      if (item.label && typeof item.label === 'string' && /[\u4e00-\u9fa5]/.test(item.label)) {
        return item.label;
      }

      // 优先使用字段配置
      if (item.key && this.fieldConfig[item.key] && this.fieldConfig[item.key].label) {
        return this.fieldConfig[item.key].label;
      }

      // 从映射表中查找 - 支持多种字段名格式（后备）
      const possibleKeys = [
        item.title, // 添加title支持
        item.label,
        item.key,
        item.code,
        item.name,
        // 尝试转换为小写
        item.title && item.title.toLowerCase(),
        item.label && item.label.toLowerCase(),
        item.key && item.key.toLowerCase(),
        // 尝试去掉空格和特殊字符
        item.title && item.title.replace(/[\s_-]/g, '').toLowerCase(),
        item.label && item.label.replace(/[\s_-]/g, '').toLowerCase(),
        item.key && item.key.replace(/[\s_-]/g, '').toLowerCase()
      ].filter(Boolean);

      for (const key of possibleKeys) {
        if (key && this.fieldNameMapping[key]) {
          return this.fieldNameMapping[key];
        }
      }

      // 如果都没有，返回有意义的默认值
      const displayName = item.title || item.label || item.key || item.code || item.name;
      return displayName || '未知字段';
    },
    // 面板调节相关方法
    startResize(type) {
      this.isResizing = true;
      this.resizeType = type;
      this.startX = event.clientX;
      this.startLeftWidth = this.leftPanelWidth;
      this.startRightWidth = this.rightPanelWidth;
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },

    handleMouseMove(event) {
      if (!this.isResizing) return;

      const deltaX = event.clientX - this.startX;
      const containerWidth = window.innerWidth - 16; // 减去左右边距(0.5rem * 2)

      if (this.resizeType === "left") {
        // 调节左侧面板宽度，中间面板自适应
        const newLeftWidth = Math.max(
          200,
          Math.min(600, this.startLeftWidth + deltaX)
        );

        // 确保留给右侧和中间面板足够空间
        const minSpaceForOthers = this.rightPanelWidth + 300; // 右侧面板宽度 + 中间面板最小宽度
        if (newLeftWidth + minSpaceForOthers + 32 <= containerWidth) {
          // 32px是两个分隔符的宽度
          this.leftPanelWidth = newLeftWidth;
        }
      } else if (this.resizeType === "middle") {
        // 调节右侧面板宽度，中间面板自适应
        const newRightWidth = Math.max(
          300,
          Math.min(600, this.startRightWidth - deltaX)
        );

        // 确保留给左侧和中间面板足够空间
        const minSpaceForOthers = this.leftPanelWidth + 300; // 左侧面板宽度 + 中间面板最小宽度
        if (newRightWidth + minSpaceForOthers + 32 <= containerWidth) {
          // 32px是两个分隔符的宽度
          this.rightPanelWidth = newRightWidth;
        }
      }
    },

    handleMouseUp() {
      if (this.isResizing) {
        this.isResizing = false;
        this.resizeType = "";
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      }
    },

    /* 刷新数据 */
    refreshData() {
      this.$message.success("刷新成功");
      // 移除 getListData() 调用，因为患者列表已经通过子组件的 statusBtn 事件更新了，避免重复调用接口
      // this.getListData();
      if (this.itemCacheChatData?.id) {
        // 不再自动调用会话列表，避免重复请求
        this.selectArchives();
      }
    },

    /* 接入聊天-接入后医生可以聊天了，ai不再回复患者 */
    joinChat(e) {
      this.$message.success("joinChat");
      // console.log("e", e);
      // if (e?.admin_id) {
      //   updateApi({
      //     id: e.id,
      //     admin_id: null
      //   }).then(res => {
      //     if (res.code === 200) {
      //       this.$message.success("已结束聊天");
      //       this.getListData();
      //       this.getDetailsData();
      //     }
      //   });
      //   return;
      // }
      // updateApi({
      //   id: e.id,
      //   admin_id: this.userInfo.id
      // }).then(res => {
      //   if (res.code === 200) {
      //     this.$message.success("接入成功");
      //     this.getListData();
      //     this.getDetailsData();
      //   }
      // });
    },

    /* 发送按钮 */
    async sendBtn(text) {
      this.$message.success("sendBtn");
      // if (!this.itemCacheChatData?.id) {
      //   return this.$message.warning("请选择会话");
      // }
      // // console.log("this.chatData", this.chatData);
      // let data = {
      //   id: null,
      //   openid: this.itemCacheChatData?.openid,
      //   phone: this.itemCacheChatData?.phone,
      //   answerNumber: this.itemCacheChatData?.id,
      //   count: this.chatData.length,
      //   msgType: 1,
      //   role: "doctor",
      //   content: text,
      //   status: 0,
      //   errorMsg: null,
      //   diseaseType: null,
      //   ai_type: this.itemCacheChatData?.ai_type,
      //   admin_id: this.userInfo.id,
      //   active_status: null,
      //   appid: null
      // };
      //   const result = await addConversationApi(data);
      //   if (result.code === 200) {
      //     this.chatData.push(data);
      //     // 安全访问refs清空输入框
      //     if (this.$refs.chatBox) {
      //       this.$refs.chatBox.textarea = "";
      //     }
      //     setTimeout(() => {
      //       if (this.$refs.chatBox && this.$refs.chatBox.$refs.chat_dom) {
      //         this.$refs.chatBox.$refs.chat_dom.scrollTo({
      //           top: this.$refs.chatBox.$refs.chat_dom.scrollHeight
      //         });
      //       }
      //     }, 300);
      //   }
    },

    /* 聚焦会话记录 */
    clickChatBtn() {
      this.type = 1;
    },
    /* 病历提取 */
    async handleArchives() {
      if (!this.chatData.length) {
        return this.$message.warning("请选择会话");
      }
      this.type = 2;
    },

    /* 病历历史 */
    async handleHistory() {
      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择患者");
      }
      this.type = 3;
      await this.loadHistoryData();
    },

    /* 加载病历历史数据 */
    async loadHistoryData() {
      if (!this.itemCacheChatData?.id) {
        this.historyData = [];
        return;
      }
      try {
        const doctor = localStorage.getItem('userId') || this.userInfo?.userId;
        const resp = await request({
          url: '/ly/archive/history',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            onlyMine: true,
            professionalId: doctor,
            pageNum: 1,
            pageSize: 20,
            visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
            // 病历历史显示HIS + medisyn两部分，不传medicalSource参数
          }
        });
        if (resp && resp.success && Array.isArray(resp.result)) {
          this.historyData = resp.result;

          // 默认展示第一条详情（不清空数据，直接更新，避免抖动）
          if (this.historyData.length > 0) {
            this.handleViewMedicalDetail(this.historyData[0].id);
          } else {
            // 没有历史数据时，加载字段模板（根据科室配置）
            await this.loadFieldTemplate();
          }
        } else {
          this.historyData = [];
          // 没有历史数据时，加载字段模板（根据科室配置）
          await this.loadFieldTemplate();
        }
      } catch (error) {
        console.error('加载病历历史失败:', error);
        this.historyData = [];
        // 出错时也尝试加载字段模板
        await this.loadFieldTemplate();
      }
    },

    /* 加载字段模板（根据科室配置） */
    async loadFieldTemplate() {
      try {
        const doctor = localStorage.getItem('userId') || this.userInfo?.id;
        if (!doctor) {
          console.warn('未找到医生ID，无法加载字段模板');
          this.medicalDetail = {};
          this.activeArchives = [];
          this.medicalDetailOriginalValues = {};
          return;
        }

        const resp = await request({
          url: '/ly/archive/fields/template',
          method: 'POST',
          data: {
            professionalId: doctor,
            departmentId: this.getCurrentDepartmentId()
          }
        });

        if (resp && resp.success) {
          const result = resp.result || {};
          // 复用 handleViewMedicalDetail 的处理逻辑
          this.medicalDetail = result.medicalDetail || {};

          // 缓存字段配置
          this.fieldConfig = {};
          if (Array.isArray(result.fields) && result.fields.length) {
            result.fields.forEach(f => {
              this.fieldConfig[f.key] = {
                label: f.label,
                key: f.key
              };
            });

            // 转为activeArchives：fields -> {key,label,value}
            this.activeArchives = result.fields.map(f => ({
              key: f.key,
              label: f.label,
              value: f.value || '',
              originalValue: f.value || '', // 记录原始值
              isEdit: false,
              isEdit_newValue: null
            }));
          } else {
            // 如果没有fields，使用空数组
            this.activeArchives = [];
          }

          // 初始化 medical-detail 区域的原始值
          this.medicalDetailOriginalValues = {};
          const excludeKeys = ['visitDate', 'medmstrId', 'consultationId'];
          Object.keys(this.medicalDetail).forEach(key => {
            if (!excludeKeys.includes(key)) {
              this.medicalDetailOriginalValues[key] = this.medicalDetail[key] || '';
            }
          });
        } else {
          // 接口调用失败，使用空数据
          this.medicalDetail = {};
          this.activeArchives = [];
          this.medicalDetailOriginalValues = {};
          this.fieldConfig = {};
        }
      } catch (error) {
        console.error('加载字段模板失败:', error);
        // 出错时使用空数据
        this.medicalDetail = {};
        this.activeArchives = [];
        this.medicalDetailOriginalValues = {};
        this.fieldConfig = {};
      }
    },

    /* 仅加载病历历史列表（用于操作记录按钮，不加载详情，避免影响主病历区域） */
    async loadHistoryListOnly() {
      if (!this.itemCacheChatData?.id) {
        this.historyData = [];
        return;
      }
      try {
        const doctor = localStorage.getItem('userId') || this.userInfo?.userId;
        const resp = await request({
          url: '/ly/archive/history',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            onlyMine: true,
            professionalId: doctor,
            pageNum: 1,
            pageSize: 20,
            visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
            // 病历历史显示HIS + medisyn两部分，不传medicalSource参数
          }
        });
        if (resp && resp.success && Array.isArray(resp.result)) {
          this.historyData = resp.result;
          // 只加载列表，不自动加载详情，避免影响主病历区域
          // 详情将在用户点击记录并打开确认弹窗时再加载
        } else {
          this.historyData = [];
        }
      } catch (error) {
        console.error('加载病历历史失败:', error);
        this.historyData = [];
      }
    },

    /* 选择历史病历记录 - 弹出确认窗口 */
    selectHistoryArchive(item) {
      this.selectedHistoryItem = item;
      this.historyVisible = false; // 关闭下拉菜单
      this.medicalHistoryConfirmVisible = true; // 显示确认弹窗
      // 不在这里调用 handleViewMedicalDetail，让 onMedicalHistoryDialogOpen 统一处理
    },

    /* 确认重新启用历史病历 */
    async confirmUseMedicalHistory() {
      if (this.selectedHistoryItem) {
        console.log('this.selectedHistoryItem', this.selectedHistoryItem);
        this.type = 2; // 切换到病历详情视图

        // 将弹层的数据复制到主病历区域
        if (this.historyDialogMedicalDetail && Object.keys(this.historyDialogMedicalDetail).length > 0) {
          // 使用弹层已加载的数据
          this.medicalDetail = { ...this.historyDialogMedicalDetail };
          this.medicalDetailOriginalValues = { ...this.historyDialogMedicalDetailOriginalValues };

          if (Array.isArray(this.historyDialogActiveArchives) && this.historyDialogActiveArchives.length > 0) {
            this.activeArchives = JSON.parse(JSON.stringify(this.historyDialogActiveArchives));
          } else {
            // 如果弹层没有 activeArchives，从 medicalDetail 构建
            this.activeArchives = this.normalizeDetailToArchives(this.medicalDetail);
          }
        } else {
          // 如果弹层数据为空，回退到原来的逻辑
          if (!Array.isArray(this.activeArchives) || this.activeArchives.length === 0) {
            if (this.medicalDetail && Object.keys(this.medicalDetail).length > 0) {
              this.activeArchives = this.normalizeDetailToArchives(this.medicalDetail);
            } else if (this.selectedHistoryItem && this.selectedHistoryItem.message) {
              try {
                const parsed = JSON.parse(this.selectedHistoryItem.message);
                this.activeArchives = Array.isArray(parsed) ? parsed : [];
              } catch (e) {
                this.activeArchives = [];
              }
            } else {
              this.activeArchives = [];
            }
          }
        }

        // 调用保存接口，copyFlag 设置为 true（不会将病历同步给AI）
        try {
          await this.saveArchives(false, true);
          this.medicalHistoryConfirmVisible = false;
          this.$message.success(`已重新启用 ${this.formatDate(this.selectedHistoryItem.visitDate)} 的病历记录`);
          this.selectedHistoryItem = null;
        } catch (error) {
          console.error('重新启用病历失败:', error);
          this.$message.error('重新启用病历失败，请重试');
        }
      }
    },

    /* 取消启用历史病历 */
    cancelUseMedicalHistory() {
      this.medicalHistoryConfirmVisible = false;
      this.selectedHistoryItem = null;
    },

    /* 在确认窗口中切换到其他病历历史 */
    switchToMedicalHistory(item) {
      this.selectedHistoryItem = item;
      if (item && item.id) {
        // 传入 true 表示弹层调用，更新弹层变量
        this.handleViewMedicalDetail(item.id, true);
      }
    },

    /* 解析病历字段 */
    getMedicalRecordFields(messageString) {
      if (!messageString) return [];
      try {
        const fields = JSON.parse(messageString);
        return Array.isArray(fields) ? fields : [];
      } catch (error) {
        console.error('解析病历字段失败:', error);
        return [{ label: '原始数据', value: messageString }];
      }
    },

    /* 格式化日期 */
    formatDate(dateString) {
      if (!dateString) return '未知日期';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    /* 格式化时间为 小时:分钟 格式（例如：00:09） */
    formatTime(dateString) {
      if (!dateString) return '--:--';
      try {
        // 处理 "2025-11-17 00:09:03" 格式
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          // 如果Date解析失败，尝试手动解析
          const match = dateString.match(/(\d{2}):(\d{2}):(\d{2})/);
          if (match) {
            // match[1]是小时，match[2]是分钟
            // 返回小时:分钟格式
            return `${match[1]}:${match[2]}`;
          }
          return '--:--';
        }
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      } catch (error) {
        console.error('时间格式化错误:', error);
        return '--:--';
      }
    },

    /* 获取历史病历诊断信息 */
    getHistoryDiagnosis(item) {
      // 新接口字段：primaryDiagnosis + visitDate
      const text = item.primaryDiagnosis || '病历记录';
      return text.length > 20 ? text.substring(0, 20) + '...' : text;
    },

    handleDetails(item) {
      console.log("handleDetails", item);
      this.type = 2;
      this.activeArchives = JSON.parse(item?.message);
    },

    /* 提取病历 - 从对话记录创建初始化病历（已废弃：现在只支持单个引用） */
    async transformArchives(item, index) {
      // 功能已废弃，不再支持全引功能
      this.$message.warning("该功能已废弃，请使用单个引用功能");
      return;

      /* 废弃代码 - 已屏蔽
      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择会话");
      }

      // 检查是否有对话内容可以提取
      const hasPatientChat = this.chatData && this.chatData.length > 0;
      const hasDoctorChat = this.chatData_doctor && this.chatData_doctor.length > 0;

      if (!hasPatientChat && !hasDoctorChat) {
        this.$message.warning("暂无对话内容可提取，请先进行问诊对话或录音");
        return;
      }

      try {
        this.loading_btn = true;

        // 构建包含所有对话的完整消息
        let allMessages = [];

        // 添加患者对话记录
        if (hasPatientChat) {
          allMessages = allMessages.concat(this.chatData.map(item => ({
          content: item.content,
          role: item.role
          })));
        }

        // 添加医生对话记录
        if (hasDoctorChat) {
          allMessages = allMessages.concat(this.chatData_doctor.map(item => ({
            content: item.content,
            role: item.role
          })));
        }

        // 检查是否有有效消息
        if (allMessages.length === 0) {
          this.loading_btn = false;
          this.$message.warning("没有找到有效的对话内容");
          return;
        }

        // 使用新的接口创建初始化病历
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: JSON.stringify(allMessages),
          medmstrId: this.itemCacheChatData?.id || '',
          professionalId: professionalId,
          departmentId: this.getCurrentDepartmentId(),
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
          includeMedicalRecords: false,
          includeTestReports: false,
          includeHistoryChat: false,
          isInitialExtraction: true // 标记这是初始化提取
        };

        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });

      this.loading_btn = false;

        if (resp && resp.success) {
          // 新接口返回的是字段建议，需要转换为病历格式
          const suggestionFields = (resp.result && resp.result.fields) || [];

          // 将AI建议转换为病历字段格式
          this.activeArchives = suggestionFields.map(field => ({
            title: field.title || field.fieldName,
            value: field.suggestedValue || '',
            isEdit: false,
            originalValue: field.suggestedValue || '',
            isEdit_newValue: null
          }));

          this.type = 2; // 切换到病历视图
          this.isViewingMedicalRecord = true;
          this.$message.success(`初始化病历创建完成！已从 ${allMessages.length} 条对话中提取病历内容`);
        } else {
          this.$message.error(resp?.message || '初始化病历创建失败');
        }
      } catch (error) {
        this.loading_btn = false;
        console.error('初始化病历创建失败:', error);
        this.$message.error("初始化病历创建失败：" + error.message);
      }
      */
    },
    /* 编辑模式 */
    editBtn(item, index, event) {
      // 先保存当前正在编辑的字段
      const currentEditingIndex = this.activeArchives.findIndex(item => item.isEdit);
      if (currentEditingIndex !== -1 && currentEditingIndex !== index) {
        // 有其他字段正在编辑，且不是当前点击的字段
        const currentEditingItem = this.activeArchives[currentEditingIndex];
        // 立即保存当前编辑的字段并关闭编辑状态
        this.saveArchives_item(currentEditingItem, currentEditingIndex, true, false);
      }

      // 记录原始值以便取消时恢复
      if (item.originalValue === undefined) {
        item.originalValue = item.value;
      }
      const clickTarget = event?.currentTarget || event?.target;
      const fieldContainer = clickTarget?.closest?.('.field-container');
      const textContainer = clickTarget?.closest?.('.editable-field-content, .original-text-field')
        || fieldContainer?.querySelector?.('.editable-field-content, .original-text-field');
      const measuredHeight = textContainer ? Math.ceil(textContainer.getBoundingClientRect().height) : 0;
      const lockedHeight = Math.max(measuredHeight, 70);
      this.$set(this.activeArchives, index, { ...item, isEdit: true, editHeight: lockedHeight });

      // 自动聚焦到输入框
      this.$nextTick(() => {
        // 根据index找到对应的输入框 - 安全访问refs
        const editInputs = this.$refs.editInput;
        if (editInputs) {
          let targetInput;
          if (Array.isArray(editInputs)) {
            // 如果有多个编辑框，找到对应index的输入框
            const currentEditingIndex = this.activeArchives.findIndex(item => item.isEdit);
            targetInput = editInputs.find((input, inputIndex) => {
              // 通过DOM查找对应的输入框
              const fieldIndex = parseInt(input.$el?.closest('.field-container')?.dataset.index || input.closest?.('.field-container')?.dataset.index);
              return fieldIndex === currentEditingIndex;
            });
          } else {
            targetInput = editInputs;
          }

          if (targetInput) {
            if (targetInput.focus) {
              targetInput.focus();
            } else if (targetInput.$el && targetInput.$el.focus) {
              targetInput.$el.focus();
            }
          }
        }
      });
    },

    /* 保存当前正在编辑的字段 */
    saveCurrentEditingField(isSwitch = false) {
      const editingIndex = this.activeArchives.findIndex(item => item.isEdit);
      if (editingIndex !== -1) {
        const editingItem = this.activeArchives[editingIndex];
        this.saveArchives_item(editingItem, editingIndex, true, isSwitch);
      }
    },

    /* 取消编辑 */
    cancelEdit(item, index) {
      // 设置取消编辑标记，防止blur事件触发保存
      this.isCancelling = true;

      // 恢复原始值
      if (item.originalValue !== undefined) {
        item.value = item.originalValue;
        delete item.originalValue;
      }
      this.$set(this.activeArchives, index, { ...item, isEdit: false });

      // 重置取消编辑标记
      this.$nextTick(() => {
        this.isCancelling = false;
      });

      // 取消编辑时明确不保存，不调用saveArchives
      console.log('取消编辑，不保存数据');
    },

    /* 编辑建议内容 - 保持红绿框显示 */
    editSuggestion(item, index, event) {
      // 进入建议编辑模式，保持红绿框和接受/拒绝按钮
      const clickTarget = event?.currentTarget || event?.target;
      const textContainer = clickTarget?.closest?.('.suggested-text, .suggested-content');
      const measuredHeight = textContainer ? Math.ceil(textContainer.getBoundingClientRect().height) : 0;
      const lockedHeight = Math.max(measuredHeight, 70);
      this.$set(this.activeArchives, index, { ...item, isEditingSuggestion: true, suggestionEditHeight: lockedHeight });

      // 自动聚焦到建议编辑输入框 - 安全访问refs
      this.$nextTick(() => {
        const editInputs = this.$refs.editSuggestionInput;
        if (editInputs && editInputs.length > 0) {
          const targetInput = Array.isArray(editInputs) ? editInputs[0] : editInputs;
          if (targetInput && targetInput.focus) {
            targetInput.focus();
          }
        }
      });
    },

    /* 完成建议编辑 */
    finishEditSuggestion(item, index) {
      // 退出建议编辑模式，保持建议状态
      this.$set(this.activeArchives, index, { ...item, isEditingSuggestion: false });
    },

    /* 处理输入框失焦事件 */
    handleInputBlur(item, index) {
      // 如果正在取消编辑，不触发保存
      if (this.isCancelling) {
        console.log('正在取消编辑，跳过blur保存');
        return;
      }

      // 检查文本是否真正改变
      const hasChanged = item.originalValue !== undefined && item.value !== item.originalValue;

      if (hasChanged) {
        console.log('文本已改变，执行保存');
        // 延迟执行，确保点击事件能够先执行
        setTimeout(() => {
          // 正常的blur，保存并退出编辑模式
          this.saveArchives_item(item, index, true, false);
        }, 100);
      } else {
        console.log('文本未改变，跳过保存');
        // 文本未改变，只退出编辑模式，不保存
        this.saveArchives_item(item, index, false, false);
      }
    },

    saveArchives_item(item, index, shouldSave = true, isSwitch = false) {
      // 清除原始值记录
      if (item.originalValue !== undefined) {
        delete item.originalValue;
      }

      // 如果不是切换字段，退出编辑模式
      if (!isSwitch) {
        this.$set(this.activeArchives, index, { ...item, isEdit: false });
      }

      if (shouldSave) {
        this.saveArchives();
      }
    },

    /* 保存病历（改用 /ly/archive/add） */
    async saveArchives(shouldReloadHistory = false, copyFlag = false) {
      // 防重复调用检查
      if (this.isSavingArchives) {
        console.log('病历正在保存中，跳过重复调用');
        return;
      }

      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择患者");
      }
      if (!this.activeArchives || this.activeArchives.length === 0) {
        return this.$message.warning("暂无病例详情可保存");
      }

      // 从 activeArchives 构建 content JSON 对象（动态字段）
      const contentObj = {};
      this.activeArchives.forEach(item => {
        // item.key 本身就是下划线命名（如 chief_complaint），直接使用
        // 包含所有字段，即使值为空，保持数据结构完整
        contentObj[item.key] = item.value || '';
      });

      // 构建 payload
      const payload = {
        medmstrId: this.itemCacheChatData.id,
        professionalId: this.userInfo.id,
        departmentId: this.getCurrentDepartmentId(),
        copyFlag: copyFlag, // 标识是否为创建副本
        visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
        content: JSON.stringify(contentObj) // 动态字段的 JSON
      };

      // 如果 chatId 不为空，则添加到请求参数中
      if (this.itemCacheChatData?.chatId && this.itemCacheChatData.chatId.trim() !== '') {
        payload.chatId = this.itemCacheChatData.chatId;
      }

      // 设置保存状态，防止重复调用
      this.isSavingArchives = true;

      // 添加调试信息
      console.log('保存病历数据:', {
        activeArchives: this.activeArchives,
        payload: payload
      });

      try {
        const resp = await request({
          url: '/ly/archive/add',
          method: 'POST',
          data: payload
        });
        if (resp && resp.success) {
          this.$message.success("病历已存档");

          // 当 copyFlag 为 true 时，调用创建会话接口同步病历给 AI
          if (copyFlag) {
            try {
              const createResult = await createConversationLy({
                medmstrId: this.itemCacheChatData?.id,
                professionalId: localStorage.getItem('userId') || this.userInfo?.id,
                departmentId: this.getCurrentDepartmentId(),
                visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
              });

              if (createResult.success && createResult.code === 200) {
                // 清空当前对话记录（与开始新的对话会话功能保持一致）
                this.chatData_doctor = [];
                this.chatData = [];

                // 重置会话状态
                this.isConversationEnded = false;

                // 更新 chatId
                this.itemCacheChatData.chatId = createResult.result.chatId;

                // 同时更新classData中对应患者的chatId，确保子组件数据同步
                const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
                if (patientIndex !== -1) {
                  this.$set(this.classData[patientIndex], 'chatId', createResult.result.chatId);
                }

                console.log('copyFlag为true时，创建会话成功，chatId:', createResult.result.chatId);
              } else {
                console.warn('copyFlag为true时，创建会话失败:', createResult.message);
              }
            } catch (error) {
              console.error('copyFlag为true时，创建会话失败:', error);
            }
          }

          // 只有在明确需要时才重新加载历史数据（如批量操作）
          if (shouldReloadHistory) {
            await this.loadHistoryData();
          }
        } else {
          this.$message.error(resp?.message || '病历存档失败');
        }
      } catch (e) {
        this.$message.error('网络错误，病历存档失败');
      } finally {
        // 无论成功或失败，都要重置保存状态
        this.isSavingArchives = false;
      }
    },

    // 防抖保存：文本变化触发
    debounceSaveArchives() {
      // 如果正在保存中，跳过防抖保存
      if (this.isSavingArchives) {
        console.log('病历正在保存中，跳过防抖保存');
        return;
      }

      if (this.saveDebounceTimer) {
        clearTimeout(this.saveDebounceTimer);
      }
      this.saveDebounceTimer = setTimeout(() => {
        this.saveArchives();
      }, 500);
    },

    // 处理 medical-detail 区域的失焦事件，检查文本是否改变
    handleMedicalDetailBlur(fieldName, event) {
      const newValue = event.target.value;
      const originalValue = this.medicalDetailOriginalValues?.[fieldName];

      // 检查文本是否真正改变
      const hasChanged = originalValue !== undefined && newValue !== originalValue;

      if (hasChanged) {
        console.log(`${fieldName} 文本已改变，执行保存`);
        this.debounceSaveArchives();
      } else {
        console.log(`${fieldName} 文本未改变，跳过保存`);
      }
    },

    // 确认结束会话
    async confirmEndConversation() {
      if (!this.itemCacheChatData?.chatId) {
        this.$message.warning('当前无可结束的会话');
        return;
      }
      try {
        await this.$confirm('结束后不可继续向该会话发送消息，确认结束？', '确认结束会话', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        const resp = await request({
          url: '/ly/conversation/end',
          method: 'POST',
          data: { conversationId: this.itemCacheChatData.chatId }
        });
        if (resp && resp.success) {
          this.isConversationEnded = true;
          this.$message.success(resp.message || '会话已结束');

          // 重置到未选择患者的空态，避免继续向该会话发送消息
          this.clearRightPanelState();
          // 刷新左侧患者列表，确保最新会话状态并清空当前患者的会话值
          this.getListData();
          // 同步左侧列表取消激活项与展开状态
          this.$nextTick(() => {
            const left = this.$refs.chatClass;
            if (left) {
              if (typeof left.active !== 'undefined') left.active = '';
              if (typeof left.expandedCards !== 'undefined') left.expandedCards = {};
              if (typeof left.collapseActiveNames !== 'undefined') left.collapseActiveNames = {};
              if (typeof left.allExpanded !== 'undefined') left.allExpanded = {};
            }
            // 结束后再次点击列表需要重新校验
            this.isConversationEnded = false;
          });
        } else {
          this.$message.error(resp?.message || '结束会话失败');
        }
      } catch (e) {
        // 用户取消
      }
    },

    /* 点击左边会话列表 */
    async clickChatClass(e) {
      // console.log("点击左边会话列表,记载聊天记录", e);
      this.itemCacheChatData = e;
      this.currentDepartmentId = e?.departmentId || "";
      if (this.currentDepartmentId) {
        localStorage.setItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY, this.currentDepartmentId);
      } else {
        localStorage.removeItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY);
      }

      // 同步 visitNum 到 localStorage，确保后续调用能够获取到
      const visitNum = e?.visitNum || e?.visitNumber;
      if (visitNum) {
        localStorage.setItem('visitNum', visitNum);
      }

      console.log('点击左边会话列表,加载聊天记录', e);

      // 默认激活病历界面
      this.type = 2;
      this.isViewingMedicalRecord = true;

      // 判断是否需要创建会话
      if (!this.itemCacheChatData?.chatId) {
        try {
          console.log('chatId为空，需要创建会话');
          const result = await createConversationLy({
            medmstrId: this.itemCacheChatData?.id,
            professionalId: localStorage.getItem('userId') || this.userInfo?.id,
            departmentId: this.getCurrentDepartmentId(),
            visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
          });

          if (result.success && result.code === 200) {
            // 同步chatId到itemCacheChatData
            this.itemCacheChatData.chatId = result.result.chatId;

            // 同时更新classData中对应患者的chatId，确保子组件数据同步
            const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
            if (patientIndex !== -1) {
              this.$set(this.classData[patientIndex], 'chatId', result.result.chatId);
            }

            console.log('会话创建成功，chatId:', result.result.chatId);

            // 创建会话时不调用selectArchives和getDetailsData_doctor
            // 只调用loadHistoryData加载历史病例并默认展示第一条详情
            this.loadHistoryData();
          } else {
            this.$message.error(result.message || "创建会话失败");
            return;
          }
        } catch (error) {
          console.error("创建会话失败：", error);
          this.$message.error("创建会话失败，请重试");
          return;
        }
      } else {
        // chatId不为空，调用所有相关接口
        console.log('chatId已存在，调用相关接口');
        this.selectArchives();  //选择病历（AI提取）- 内部已调用loadHistoryData()

        // 加载该患者的AI与医生聊天记录
        await this.loadPatientChatHistory();
      }
    },

    // 加载患者的AI与医生聊天记录
    async loadPatientChatHistory() {
      if (!this.itemCacheChatData?.chatId) {
        console.log('没有chatId，无法加载聊天记录');
        this.chatData_doctor = [];
        return;
      }

      try {
        console.log('加载患者聊天记录，chatId:', this.itemCacheChatData.chatId);

        // 调用详情接口获取聊天记录
        const res = await request({
          url: `/ly/conversation/detail`,
          method: "POST",
          data: { conversationId: this.itemCacheChatData.chatId }
        });

        if (res && res.success && res.result) {
          const messages = res.result.conversationData || [];
          console.log('获取到的患者聊天记录:', messages);

          // 转换为chatData_doctor格式
          this.chatData_doctor = messages.map(m => ({
            role: m.senderType === 'doctor' ? 'user' : 'assistant',
            content: m.content,
            createTime: m.createTime,
            senderType: m.senderType,
            id: m.id,
            audioFilePath: m.audioFilePath || '' // 加载音频文件路径，支持重新编辑时播放
          }));

          console.log('加载患者聊天记录条数:', this.chatData_doctor.length);
        } else {
          console.log('获取患者聊天记录失败:', res?.message);
          this.chatData_doctor = [];
        }
      } catch (error) {
        console.error('加载患者聊天记录失败:', error);
        this.chatData_doctor = [];
      }
    },

    // 旧的 selectArchives 接口已废弃，改为加载历史并联动详情
    async selectArchives() {
      await this.loadHistoryData();
    },

    /* 根据就诊状态筛选数据 */
    statusBtn(item) {
          // 如果item包含patientList，需要映射数据格式
          if (item.patientList && Array.isArray(item.patientList)) {
            // 对患者列表数据进行映射，确保字段完整
            const mappedData = item.patientList.map(r => ({
              id: r.id,
              realname: r.realname,
              username: r.username,
              visitStatus: r.visitStatus,
              visitStatusText: r.visitStatusText,
              age: r.age,
              sex: r.sex,
              sexText: r.sexText,
              chatSummary: r.chatSummary,
              chatId: r.chatId,
              visitNum: r.visitNum,
              visitNumber: r.visitNum, // 别名，用于排序
              phone: r.phone || r.username || '', // 确保phone字段存在
              departmentId: r.departmentId || '',
              departmentName: r.departmentName
            }));
            
            // 先清空再赋值，确保触发响应式更新
            this.classData = [];
            this.$nextTick(() => {
              this.classData = mappedData;
            });
            
            // 更新总数（如果子组件传递了total）
            if (item.total !== undefined) {
              this.listQuery.total = item.total;
            }
            return;
          }else{
    		  // 否则使用原有逻辑
    		  this.listQuery.medical_status = item.id;
    		  this.getListData();
    	  }
        },

    /* 修改状态 */
    async updateStatusBtn(medical_status, item) {
      const result = await updateApi({
        id: item.id,
        medical_status: medical_status.id
      });
      if (result.code === 200) {
        this.$message.success("修改成功");
        this.getListData();
      }
    },


    /* 排序数据 */
    sortData(sortConfig) {
      let sortedData = [...this.classData];

      switch (sortConfig.field) {
        case 'name':
          sortedData.sort((a, b) => {
            const nameA = a.name || '';
            const nameB = b.name || '';
            return sortConfig.ascending ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
          });
          break;
        case 'age':
          sortedData.sort((a, b) => {
            const ageA = a.age || 0;
            const ageB = b.age || 0;
            return sortConfig.ascending ? ageA - ageB : ageB - ageA;
          });
          break;
        case 'gender':
          sortedData.sort((a, b) => {
            const genderA = a.sex || 0;
            const genderB = b.sex || 0;
            return sortConfig.ascending ? genderA - genderB : genderB - genderA;
          });
          break;
        case 'checkInTime':
          sortedData.sort((a, b) => {
            const timeA = new Date(a.checkInTime || a.created_at || 0);
            const timeB = new Date(b.checkInTime || b.created_at || 0);
            return sortConfig.ascending ? timeA - timeB : timeB - timeA;
          });
          break;
        case 'visitNumber':
          sortedData.sort((a, b) => {
            const numA = a.visitNumber || a.visitNum || a.id || 0;
            const numB = b.visitNumber || b.visitNum || b.id || 0;
            return sortConfig.ascending ? numA - numB : numB - numA;
          });
          break;
        default:
          
          return;
      }
	  
	  this.getListData(); // 默认排序重新获取数据
      this.classData = sortedData;
    },

    /* 清空病历 */
    clearMedicalRecord() {
      if (!this.activeArchives || this.activeArchives.length === 0) {
        this.visible = false;
        this.$message.warning('当前无病历内容可清空');
        return;
      }

      // 清空所有字段的内容，但保留字段结构
      let clearedCount = 0;
      this.activeArchives = this.activeArchives.map(item => {
        if (item.value && item.value.trim() !== '') {
          clearedCount++;
        }
        return {
          ...item,
          value: '', // 清空字段内容
          isEdit: false, // 确保不在编辑状态
          isEdit_newValue: null // 清空AI建议
        };
      });

      this.visible = false;

      if (clearedCount > 0) {
        // 触发自动保存
        this.saveArchives(true); // 清空操作后重新加载历史数据
        this.$message.success(`已清空 ${clearedCount} 个字段内容并保存`);
      } else {
        this.$message.info('所有字段内容已为空');
      }
    },

    /* 清空病历（仅清空内容，不保存） */
    async clearMedicalRecordOnly() {
      // 检查是否有患者信息
      if (!this.itemCacheChatData?.id) {
        this.visible = false;
        return this.$message.warning("请选择患者");
      }

      let hasContent = false;

      // 1. 清空 activeArchives（动态模板字段）
      if (this.activeArchives && this.activeArchives.length > 0) {
        this.activeArchives = this.activeArchives.map(item => {
          if (item.value && item.value.trim() !== '') {
            hasContent = true;
          }
          return {
            ...item,
            value: '', // 清空字段内容
            isEdit: false, // 确保不在编辑状态
            isEdit_newValue: null, // 清空AI建议
            originalValue: '' // 清空原始值
          };
        });
      }

      // 2. 清空 medicalDetail（病例详情对象）
      if (this.medicalDetail && Object.keys(this.medicalDetail).length > 0) {
        // 排除非字段属性，只清空实际存在的字段
        const excludeKeys = ['visitDate', 'medmstrId', 'consultationId'];
        Object.keys(this.medicalDetail).forEach(field => {
          if (!excludeKeys.includes(field) && this.medicalDetail[field] &&
              (typeof this.medicalDetail[field] === 'string' && this.medicalDetail[field].trim() !== '')) {
            hasContent = true;
            this.medicalDetail[field] = '';
          }
        });

        // 同时清空原始值记录
        this.medicalDetailOriginalValues = {};
      }

      // 3. 清空 emptyTemplateData（空模板数据）
      const templateFields = [
        'chiefComplaint',
        'presentIllness',
        'pastHistory',
        'allergyHistory',
        'familyHistory',
        'marriageBearingHistory',
        'tobaccoAlcoholHistory',
        'vitalSigns',
        'physicalExamination',
        'primaryDiagnosis',
        'treatmentPlan'
      ];

      templateFields.forEach(field => {
        if (this.emptyTemplateData[field] && this.emptyTemplateData[field].trim() !== '') {
          hasContent = true;
          this.emptyTemplateData[field] = '';
        }
      });

      // 4. 调用后端接口清空病历（如果有内容）
      if (hasContent) {
        try {
          // 构建请求参数，参考 saveArchives 方法
          const payload = {
            medmstrId: this.itemCacheChatData.id,
          professionalId: this.userInfo?.id || localStorage.getItem('userId'),
          departmentId: this.getCurrentDepartmentId(),
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
          };

          // 如果 chatId 不为空，则添加到请求参数中
          if (this.itemCacheChatData?.chatId && this.itemCacheChatData.chatId.trim() !== '') {
            payload.chatId = this.itemCacheChatData.chatId;
          }

          const resp = await request({
            url: '/ly/archive/clear',
            method: 'POST',
            data: payload
          });

          if (resp && resp.success) {
            this.visible = false;
            this.$message.success('已清空所有病历内容');

            // 清空病历成功后，创建新会话
            await this.createNewConversationAfterClear();
          } else {
            this.visible = false;
            this.$message.error(resp?.message || '新建病历失败');
          }
        } catch (error) {
          console.error('新建病历失败:', error);
          this.visible = false;
          this.$message.error('网络错误，新建病历失败');
        }
      } else {
        // 如果没有内容，静默处理，不显示提示（新建病历时本来就没有内容）
        // 但仍然需要创建新会话，确保是一个全新的会话
        this.visible = false;
        await this.createNewConversationAfterClear();
      }
    },

    /* 创建新会话（新建病历后调用） */
    async createNewConversationAfterClear() {
      try {
        const createResult = await createConversationLy({
          medmstrId: this.itemCacheChatData?.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.getCurrentDepartmentId(),
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
        });

        if (createResult.success && createResult.code === 200) {
          // 更新chatId
          this.itemCacheChatData.chatId = createResult.result.chatId;

          // 同时更新classData中对应患者的chatId，确保子组件数据同步
          const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
          if (patientIndex !== -1) {
            this.$set(this.classData[patientIndex], 'chatId', createResult.result.chatId);
          }

          // 清空右侧会话内容（因为这是一个新的会话id了）
          this.chatData_doctor = [];
          this.chatData = [];

          // 重置会话状态
          this.isConversationEnded = false;

          console.log('新建病历后新会话创建成功，chatId:', createResult.result.chatId);
        } else {
          console.error('新建病历后创建新会话失败:', createResult.message);
        }
      } catch (error) {
        console.error('新建病历后创建新会话失败:', error);
      }
    },

    /* 全引按钮功能 - 提取完整病历内容（已废弃：现在只支持单个引用） */
    async extractFullContent() {
      // 功能已废弃，不再支持全引功能
      this.$message.warning("该功能已废弃，请使用单个引用功能");
      return;

      /* 废弃代码 - 已屏蔽
      // 检查是否有任何对话内容可以提取
      const hasPatientChat = this.chatData && this.chatData.length > 0;
      const hasDoctorChat = this.chatData_doctor && this.chatData_doctor.length > 0;

      if (!hasPatientChat && !hasDoctorChat) {
        this.$message.warning("暂无对话内容可提取，请先进行问诊对话");
        return;
      }

      if (!this.itemCacheChatData?.chatId) {
        return this.$message.warning("请选择会话");
      }

      try {
        this.loading_btn = true;

        // 构建包含所有对话的完整消息
        let allMessages = [];

        // 添加患者对话记录
        if (hasPatientChat) {
          allMessages = allMessages.concat(this.chatData.map(item => ({
            content: item.content,
            role: item.role
          })));
        }

        // 添加医生对话记录
        if (hasDoctorChat) {
          allMessages = allMessages.concat(this.chatData_doctor.map(item => ({
            content: item.content,
            role: item.role
          })));
        }

        // 检查是否有有效消息
        if (allMessages.length === 0) {
          this.loading_btn = false;
          this.$message.warning("没有找到有效的对话内容");
          return;
        }

        this.type = 2; // 切换到病历视图

        // 使用与单引相同的接口和参数格式
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: JSON.stringify(allMessages),
          medmstrId: this.itemCacheChatData?.id || '',
          professionalId: professionalId,
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
          includeMedicalRecords: false,
          includeTestReports: false,
          includeHistoryChat: false
        };

        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        this.loading_btn = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          this.mergeArchivesSuggestions(suggestionFields);
          this.$message.success(`全引完成！已从 ${allMessages.length} 条对话中提取病历内容`);
        } else {
          this.$message.error(resp?.message || '全引病历内容失败');
        }
      } catch (error) {
        this.loading_btn = false;
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
        console.error('全引病历内容失败:', error);
        this.$message.error("全引病历内容失败：" + error.message);
      }
      */
    },

    async getListData() {
		console.log("=========getListData===========")
      // 调用正确的患者列表接口 /ly/patient/list
      try {
        this.loading = true;
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const resp = await request({
          url: '/ly/patient/list',
          method: 'POST',
          data: {
            pageNo: 1,
            pageSize: 1000,
            keyword: '',
            professionalId: professionalId,
            sortField: '',
            sortOrder: 'asc',
            visitStatus: 0
          }
        });
        if (resp && resp.success && resp.result && resp.result.records) {
			debugger
			
          // 正确映射API返回的数据
          this.classData = resp.result.records.map(r => ({
            id: r.id,
            realname: r.realname,
            username: r.username,
            visitStatus: r.visitStatus,
            visitStatusText: r.visitStatusText,
            age: r.age,
            sex: r.sex,
            sexText: r.sexText,
            chatSummary: r.chatSummary,
            chatId: r.chatId,
            visitNum: r.visitNum,
            visitNumber: r.visitNum, // 别名，用于排序
            phone: r.phone || r.username || '', // 确保phone字段存在
            departmentId: r.departmentId || '',
            departmentName: r.departmentName || '' // 科室名称
          }));
          this.listQuery.total = resp.result.total;
        } else {
          this.classData = [];
        }
      } catch (error) {
        console.error("获取患者列表失败：", error);
        this.$message.error("获取患者列表失败，请重试");
        this.classData = [];
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },

    /* 查询聊天记录（已废弃旧接口，此处加载会话列表用于展示下拉/弹窗） */
    async getDetailsData() {
      // 不再自动调用会话列表，避免重复请求
      console.log('getDetailsData 已废弃，不再自动加载会话列表');
    },

    /* 查询医生聊天记录（旧接口废弃，合并为会话列表加载） */
    async getDetailsData_doctor() {
      // 不再自动调用会话列表，避免重复请求
      console.log('getDetailsData_doctor 已废弃，不再自动加载会话列表');
    },

    /* 上传录音文件 - 已废弃，统一使用 handleShibie 方法 */
    async uploadRecording(e) {
      // 这个方法已经不再使用，录音处理统一在 handleShibie 中完成
      console.warn("uploadRecording 方法已废弃，请使用 handleShibie 方法");
      return null;
    },

    /* 识别语音 - 优化后的录音处理流程 */
    async handleShibie(audioBlob, chatGroup) {
      if (!audioBlob) {
        return this.$message.warning("没有录音数据");
      }

      // 显示loading状态
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在识别录音，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'large-loading'
      });

      try {
        // 构建上传参数
        const formData = new FormData();
        const fileName = `录音_${new Date().getTime()}.webm`;
        formData.append('file', audioBlob, fileName);
        const name = `医患对话录音_${new Date().toLocaleString()}`;
        formData.append('name', name);
        const description = '医生与患者对话录音';
        formData.append('description', description);
        const category = 'consultation';
        formData.append('category', category);
        const tags = '医患对话,症状描述,问诊记录';
        formData.append('tags', tags);

        // 添加会话相关信息（此时已经确保有患者ID）
        formData.append('chatId', this.itemCacheChatData.chatId);
        formData.append('medmstrId', this.itemCacheChatData.id);
        formData.append('role', 'doctor'); // 录音来自医生
        formData.append('departmentId', this.getCurrentDepartmentId());
        formData.append('visitNum', this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '');
        // 门诊病历不需要 chatGroup，只有住院病历才需要（根据标签页传入 1/2/3）
        const finalChatGroup = chatGroup !== undefined && chatGroup !== null && chatGroup !== '' ? chatGroup : this.getChatGroupByView();
        if (finalChatGroup !== undefined && finalChatGroup !== null && finalChatGroup !== '') {
          formData.append('chatGroup', finalChatGroup);
        }

        // 调用统一的上传接口
        const resp = await request({
          url: '/ly/midRecord/upload',
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (resp && resp.success) {
          // 现在接口直接返回字符串，不再是对象
          this.audioMessage = resp.result?.audioMessage;
          // 暂时将两个字段都填充成一样的内容
          this.extractedMessage = resp.result?.extractedMessage;
          this.audioURL = resp.result?.audioFilePath || '';
          // 保存音频文件路径供对话框使用（PC 播放优先使用 localAudioFilePath）
          this.currentAudioFilePath = this.normalizeAudioSrc(resp.result?.localAudioFilePath || resp.result?.audioFilePath || '');
          // 关闭loading
          loadingInstance.close();

          // 弹出对话框供用户编辑
          this.dialogFormVisible = true;
        } else {
          loadingInstance.close();
          this.$message.error("语音识别失败：" + (resp?.message || "未知错误"));

          // 保存失败的录音记录
          await this.saveFailedRecordingToStorage(audioBlob, {
            fileName,
            name,
            description,
            category,
            tags,
            chatId: this.itemCacheChatData.chatId,
            medmstrId: this.itemCacheChatData.id,
            role: 'doctor',
            error: resp?.message || "未知错误"
          });
        }
      } catch (error) {
        loadingInstance.close();
        console.error("录音识别过程出错：", error);
        this.$message.error("录音识别失败，请重试");

        // 保存失败的录音记录
        await this.saveFailedRecordingToStorage(audioBlob, {
          fileName: `录音_${new Date().getTime()}.webm`,
          name: `医患对话录音_${new Date().toLocaleString()}`,
          description: '医生与患者对话录音',
          category: 'consultation',
          tags: '医患对话,症状描述,问诊记录',
          chatId: this.itemCacheChatData.chatId,
          medmstrId: this.itemCacheChatData.id,
          role: 'doctor',
          error: error.message || "网络异常"
        });
      }
    },

    /* 保存失败的录音记录到存储 */
    async saveFailedRecordingToStorage(audioBlob, metadata) {
      try {
        await saveFailedRecording(audioBlob, metadata);
        console.log('失败的录音已保存，可以稍后重试');

        // 通知 chatBox_doctor 组件刷新失败录音列表
        if (this.$refs.chatBoxDoctor) {
          this.$refs.chatBoxDoctor.loadFailedRecordings();
        }
      } catch (error) {
        console.error('保存失败录音记录出错：', error);
      }
    },

    /* 重试失败的录音 */
    async retryFailedRecording(recordingId) {
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在重试录音识别...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'large-loading'
      });

      try {
        // 从存储中获取录音 Blob
        const { getRecordingBlob, getFailedRecordingsMeta, deleteFailedRecording } = await import('@/utils/recordingStorage');

        const audioBlob = await getRecordingBlob(recordingId);
        if (!audioBlob) {
          loadingInstance.close();
          this.$message.error('无法获取录音文件');
          return;
        }

        // 获取元信息
        const metaList = getFailedRecordingsMeta();
        const metadata = metaList.find(m => m.id === recordingId);
        if (!metadata) {
          loadingInstance.close();
          this.$message.error('无法获取录音信息');
          return;
        }

        // 构建上传参数
        const formData = new FormData();
        formData.append('file', audioBlob, metadata.fileName);
        formData.append('name', metadata.name);
        formData.append('description', metadata.description);
        formData.append('category', metadata.category);
        formData.append('tags', metadata.tags);
        formData.append('chatId', metadata.chatId);
        formData.append('medmstrId', metadata.medmstrId);
        formData.append('role', metadata.role);
        formData.append('departmentId', this.getCurrentDepartmentId());
        formData.append('visitNum', this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '');
        // 调用统一的上传接口
        const resp = await request({
          url: '/ly/midRecord/upload',
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (resp && resp.success) {
          // 成功后删除失败记录
          await deleteFailedRecording(recordingId);

          // 刷新失败录音列表
          if (this.$refs.chatBoxDoctor) {
            this.$refs.chatBoxDoctor.loadFailedRecordings();
          }

          // 现在接口直接返回字符串，不再是对象
          this.audioMessage = resp.result?.audioMessage;
          this.extractedMessage = resp.result?.extractedMessage;
          this.audioURL = resp.result?.audioFilePath || '';
          // 保存音频文件路径供对话框使用（PC 播放优先使用 localAudioFilePath）
          this.currentAudioFilePath = this.normalizeAudioSrc(resp.result?.localAudioFilePath || resp.result?.audioFilePath || '');

          loadingInstance.close();
          this.$message.success('录音识别成功！');

          // 弹出对话框供用户编辑
          this.dialogFormVisible = true;
        } else {
          loadingInstance.close();
          this.$message.error("语音识别失败：" + (resp?.message || "未知错误"));
        }
      } catch (error) {
        loadingInstance.close();
        console.error("重试录音识别出错：", error);
        this.$message.error("重试失败，请稍后再试");
      }
    },

    /* 发送按钮 */
    async sendBtn_doctor(text, audioFilePath = '') {
      if (!this.itemCacheChatData?.chatId) {
        return this.$message.warning("请选择会话");
      }

      // 格式化当前时间为 "YYYY-MM-DD HH:mm:ss" 格式
      const getCurrentTimeString = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

      // 构建用户消息数据
      let userMessage = {
        id: null,
        openid: this.itemCacheChatData?.openid,
        phone: this.itemCacheChatData?.phone,
        answerNumber: this.itemCacheChatData?.id,
        count: this.chatData_doctor.length - 1,
        msgType: 1,
        role: "user",
        content: text,
        status: 0,
        errorMsg: null,
        diseaseType: null,
        ai_type: this.itemCacheChatData?.ai_type,
        admin_id: this.userInfo.id,
        active_status: null,
        appid: null,
        isRecordingContent: this.isFromRecording, // 标记是否来自录音
        audioFilePath: audioFilePath, // 音频文件路径
        createTime: getCurrentTimeString() // 添加当前时间作为默认值
      };

      // 安全访问refs清空输入框
      if (this.$refs.chatBoxDoctor) {
        this.$refs.chatBoxDoctor.textarea = "";
      }

      // 重置录音标记
      this.isFromRecording = false;

      // 添加用户消息到对话区域
      this.chatData_doctor.push(userMessage);
      setTimeout(() => {
        // 安全访问refs滚动到底部
        if (this.$refs.chatBoxDoctor && this.$refs.chatBoxDoctor.$refs && this.$refs.chatBoxDoctor.$refs.chat_dom) {
          this.$refs.chatBoxDoctor.$refs.chat_dom.scrollTo({
            top: this.$refs.chatBoxDoctor.$refs.chat_dom.scrollHeight
          });
        }
      }, 600);

      try {
        // 调用新的发送消息接口
        const result = await sendMessageLy({
          chatId: this.itemCacheChatData?.chatId,
          message: text,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.getCurrentDepartmentId(),
          audioFilePath: audioFilePath, // 传递音频文件路径
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
        });

        if (result.success && result.code === 200) {
          // 构建AI回复消息数据
          let aiMessage = {
            id: result.result.messageId,
            openid: this.itemCacheChatData?.openid,
            phone: this.itemCacheChatData?.phone,
            answerNumber: this.itemCacheChatData?.id,
            count: this.chatData_doctor.length,
            msgType: 1,
            role: "assistant",
            content: result.result.aiReturnMsg,
            status: 0,
            errorMsg: null,
            diseaseType: null,
            ai_type: this.itemCacheChatData?.ai_type,
            admin_id: this.userInfo.id,
            active_status: null,
            appid: null,
            isRecordingContent: false,
            createTime: getCurrentTimeString() // 添加当前时间作为默认值
          };

          // 添加AI回复到对话区域
          this.chatData_doctor.push(aiMessage);
          setTimeout(() => {
            // 安全访问refs滚动到底部
            if (this.$refs.chatBoxDoctor && this.$refs.chatBoxDoctor.$refs && this.$refs.chatBoxDoctor.$refs.chat_dom) {
              this.$refs.chatBoxDoctor.$refs.chat_dom.scrollTo({
                top: this.$refs.chatBoxDoctor.$refs.chat_dom.scrollHeight
              });
            }
          }, 600);
        } else {
          this.$message.error(result.message || "发送失败");
        }
      } catch (error) {
        console.error("发送消息失败：", error);
        this.$message.error("发送消息失败，请重试");
      }
    },
    /* 单条引用 */
    createByOneBtn(item) {
      console.log("createByOneBtn", item);
      this.createBtn([item]);
    },
    /* 医生发送按钮 */
    async sendBtn(text) {
      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择会话");
      }
      // console.log("this.chatData", this.chatData);
      let data = {
        id: null
      };
    },

    /* 拒绝并清空 - 删除当前会话，清空聊天框，创建新会话 */
    async deleteBtn() {
      if (!this.itemCacheChatData?.chatId) {
        this.$message.warning("当前无可删除的会话");
        return;
      }

      // 检查是否有对话内容
      if (!this.chatData_doctor || this.chatData_doctor.length === 0) {
        this.$message.warning("当前没有对话内容，无需拒绝并清空");
        return;
      }

      try {
        await this.$confirm('拒绝并清空将删除当前会话并创建新会话，是否继续？', '确认拒绝并清空', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 1. 删除当前会话
        const deleteResp = await request({
          url: '/ly/conversation/delete',
          method: 'POST',
          data: {
            conversationId: this.itemCacheChatData.chatId
          }
        });

        if (!deleteResp || !deleteResp.success) {
          this.$message.error(deleteResp?.message || '删除会话失败');
          return;
        }

        // 2. 清空聊天框内容
        this.chatData_doctor = [];
        this.chatData = [];

        // 3. 创建新会话
        const createResult = await createConversationLy({
          medmstrId: this.itemCacheChatData?.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.getCurrentDepartmentId(),
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
        });

        if (createResult.success && createResult.code === 200) {
          // 更新chatId
          this.itemCacheChatData.chatId = createResult.result.chatId;

          // 同时更新classData中对应患者的chatId，确保子组件数据同步
          const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
          if (patientIndex !== -1) {
            this.$set(this.classData[patientIndex], 'chatId', createResult.result.chatId);
          }

          console.log('新会话创建成功，chatId:', createResult.result.chatId);
          this.$message.success('已拒绝并清空，新会话已创建');
        } else {
          this.$message.error(createResult.message || "创建新会话失败");
        }

      } catch (error) {
        if (error !== 'cancel') {
          console.error("拒绝并清空失败：", error);
          this.$message.error("操作失败，请重试");
        }
      }
    },

    /* 全量匹配/部分匹配，提取，是否采纳 */
    async createBtn(data) {
      console.log("this.itemCacheChatData", this.itemCacheChatData);
      if (!this.itemCacheChatData?.chatId) {
        return this.$message.warning("请选择会话");
      }
      this.type = 2; // 切换到病例视图

      // 单条引用：content 为本次引用文本，直接传文本字符串
      console.log("data", data);
      // 提取文本内容：data可能是数组[item]或单个对象
      let contentText = '';
      if (data && Array.isArray(data) && data.length > 0) {
        // 数组情况，取第一个元素的content
        contentText = data[0].content || '';
      } else if (data && typeof data === 'object' && data.content) {
        // 单个对象情况
        contentText = data.content || '';
      } else if (typeof data === 'string') {
        // 直接是字符串
        contentText = data;
      }

      if (!contentText) {
        return this.$message.warning("请选择要引用的内容");
      }

      console.log("contentText", contentText);
      const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
      const payload = {
        chatId: this.itemCacheChatData.chatId,
        content: contentText,
        medmstrId: this.itemCacheChatData?.id || '',
        professionalId: professionalId,
        departmentId: this.getCurrentDepartmentId(),
        visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
        includeMedicalRecords: false,//修改成false，可以只引用当前病历
        includeTestReports: false,
        includeHistoryChat: false
      };

      try {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          console.log('API返回的建议字段:', suggestionFields);

          // 检查当前是否没有病历数据
          const hasNoMedicalData = !(this.medicalDetail && Object.keys(this.medicalDetail).length) && !this.activeArchives.length;
          console.log('是否没有病历数据:', hasNoMedicalData, 'medicalDetail:', this.medicalDetail, 'activeArchives.length:', this.activeArchives.length);

          if (hasNoMedicalData) {
            // 没有病历数据时，创建空字段并填充AI建议
            console.log('调用createEmptyArchivesWithSuggestions');
            this.createEmptyArchivesWithSuggestions(suggestionFields);
            this.$message.success('已创建病历并填充AI建议');
          } else if (this.activeArchives.length > 0) {
            // 已有动态模板时，合并AI建议
            console.log('调用mergeArchivesSuggestions');
            this.mergeArchivesSuggestions(suggestionFields);
            this.$message.success('已根据AI建议更新病历内容');
          } else {
            // 在已有病历状态下，使用原有的建议合并逻辑
            console.log('调用mergeArchivesSuggestions (else)');
          this.mergeArchivesSuggestions(suggestionFields);
          this.$message.success('已根据AI建议定位到对应字段');
          }
        } else {
          this.$message.error(resp?.message || '引用失败');
        }
      } catch (e) {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
        this.$message.error('引用失败，请重试');
      }
    },

    /* 修改弹窗 */
    async updateBtn(messageItem) {
      this.dialogFormVisible = true;
      // 如果传入的是完整消息对象
      if (messageItem && typeof messageItem === 'object') {
        this.audioMessage = messageItem.content || '';
        this.extractedMessage = messageItem.content || '';
        // 从消息中提取音频路径（如果存在），PC 播放优先 localAudioFilePath
        this.currentAudioFilePath = this.normalizeAudioSrc(messageItem.localAudioFilePath || messageItem.audioFilePath || '');
      } else {
        // 兼容旧的方式，传入的是字符串
        const content = messageItem;
        this.audioMessage = content;
        this.extractedMessage = content;
        this.currentAudioFilePath = '';
      }
    },
    /* 重新提取内容 */
    async reExtractMessage() {
      if (!this.audioMessage || this.audioMessage.trim() === '') {
        this.$message.warning('请先输入原始记录内容');
        return;
      }

      if (!this.itemCacheChatData?.chatId) {
        this.$message.warning('请先选择会话');
        return;
      }

      try {
        this.extractLoading = true;

        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: this.audioMessage,
          medmstrId: this.itemCacheChatData?.id || '',
          consultationId: '', // 根据实际需要填写
          departmentId: this.getCurrentDepartmentId(),
          includeMedicalRecords: true,
          includeTestReports: true,
          includeHistoryChat: true
        };

        const response = await request({
          url: '/ly/midRecord/extractedMessage',
          method: 'POST',
          data: payload
        });

        if (response && response.success && response.result) {
          this.extractedMessage = response.result;
          this.$message.success('内容提取成功');
        } else {
          this.$message.error(response?.message || '内容提取失败');
        }
      } catch (error) {
        console.error('重新提取内容失败:', error);
        this.$message.error('网络错误，内容提取失败');
      } finally {
        this.extractLoading = false;
      }
    },

    /* 清空音频路径 */
    clearAudioPath() {
      this.currentAudioFilePath = '';
      this.audioRetryLoading = false;
    },

    /* 重新上传音频 */
    async handleRetryRecording() {
      if (!this.currentAudioFilePath) {
        this.$message.error('没有可重新上传的音频文件');
        return;
      }

      this.audioRetryLoading = true;
      try {


        // 获取音频文件
        const response = await fetch(this.currentAudioFilePath);
        if (!response.ok) {
          throw new Error('获取音频文件失败');
        }
        const audioBlob = await response.blob();
        // 关闭当前对话框
        this.dialogFormVisible = false;

        // 使用原有的录音识别流程上传
        await this.handleShibie(audioBlob);

        this.$message.success('音频重新上传成功');
      } catch (error) {
        console.error('重新上传音频失败:', error);
        this.$message.error('重新上传音频失败：' + (error.message || '未知错误'));
      } finally {
        this.audioRetryLoading = false;
      }
    },

    async handleSend() {
      this.dialogFormVisible = false;

      // 标记这是来自录音的内容
      this.isFromRecording = true;

      // 使用提取内容作为发送内容
      const parsedContent = this.extractedMessage || this.audioMessage;

      // 清空输入框
      this.audioMessage = "";
      this.extractedMessage = "";

      try {
        // 1. 先发送消息到聊天，传递audioFilePath
        await this.sendBtn_doctor(parsedContent, this.currentAudioFilePath);

        // 2. 然后同步到病例区（调用/ly/archive/create接口）
        if (!this.itemCacheChatData?.chatId) {
          return;
        }

        this.type = 2; // 切换到病例视图

        // 组装引用接口入参，使用提取的内容，直接传文本字符串
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: parsedContent,
          medmstrId: this.itemCacheChatData?.id || '',
          professionalId: professionalId,
          departmentId: this.getCurrentDepartmentId(),
          visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
          includeMedicalRecords: false,//修改成false，可以只引用当前病历
          includeTestReports: false,
          includeHistoryChat: false
        };

        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          console.log('API返回的建议字段:', suggestionFields);

          // 检查当前是否没有病历数据
          const hasNoMedicalData = !(this.medicalDetail && Object.keys(this.medicalDetail).length) && !this.activeArchives.length;
          console.log('是否没有病历数据:', hasNoMedicalData, 'medicalDetail:', this.medicalDetail, 'activeArchives.length:', this.activeArchives.length);

          if (hasNoMedicalData) {
            // 没有病历数据时，创建空字段并填充AI建议
            console.log('调用createEmptyArchivesWithSuggestions');
            this.createEmptyArchivesWithSuggestions(suggestionFields);
            this.$message.success('消息已发送并同步到病例');
          } else if (this.activeArchives.length > 0) {
            // 已有动态模板时，合并AI建议
            console.log('调用mergeArchivesSuggestions');
            this.mergeArchivesSuggestions(suggestionFields);
            this.$message.success('消息已发送并同步到病例');
          } else {
            // 在已有病历状态下，使用原有的建议合并逻辑
            console.log('调用mergeArchivesSuggestions (else)');
            this.mergeArchivesSuggestions(suggestionFields);
            this.$message.success('消息已发送并同步到病例');
          }
        } else {
          this.$message.warning(resp?.message || '消息已发送，但同步到病例失败');
        }
      } catch (e) {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
        console.error('同步到病例失败:', e);
        this.$message.warning('消息已发送，但同步到病例时出错');
      }
    },

    /* 初始化进度 */
    initSubmitProgress() {
      this.showQuickSubmitModal = true;
      this.submitProgress = 0;
      this.submitProgressText = '正在初始化...';
      this.currentSubmitStep = 0;
      this.submitError = '';
    },

    /* 更新进度 */
    updateSubmitProgress(stepIndex, percentage, text) {
      this.currentSubmitStep = stepIndex;
      this.submitProgress = percentage;
      this.submitProgressText = text;
    },

    /* 完成进度 */
    completeSubmitProgress() {
      this.submitProgress = 100;
      this.submitProgressText = '处理完成！';
      this.currentSubmitStep = this.submitSteps.length;

      // 立即显示成功消息
      this.$message.success('所有操作已成功完成！');

      // 立即关闭模态框
      this.showQuickSubmitModal = false;
    },

    /* 失败进度 */
    failSubmitProgress(errorMessage) {
      this.submitError = errorMessage;
      this.submitProgressText = '处理失败';
    },

    /* 全部接受并提交HIS（带进度显示） */
    async handleAcceptAllAndSubmit() {
      this.initSubmitProgress();

      try {
        // 第一步：处理录音内容
        this.updateSubmitProgress(0, 10, '正在初始化处理...');
        this.isFromRecording = true;
        const parsedContent = this.extractedMessage || this.audioMessage;
        this.audioMessage = "";
        this.extractedMessage = "";
        this.dialogFormVisible = false;

        try {
          // 1. 发送消息到聊天，传递audioFilePath
          this.updateSubmitProgress(1, 25, '正在发送消息到聊天记录...');
          await this.sendBtn_doctor(parsedContent, this.currentAudioFilePath);

          // 2. 同步到病例区
          this.updateSubmitProgress(1, 40, '正在将录音内容引用到病历...');
          if (!this.itemCacheChatData?.chatId) {
            throw new Error('没有有效的会话ID');
          }

          this.type = 2;

          const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
          const payload = {
            chatId: this.itemCacheChatData.chatId,
            content: parsedContent,
            medmstrId: this.itemCacheChatData?.id || '',
            professionalId: professionalId,
            departmentId: this.getCurrentDepartmentId(),
            visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
            includeMedicalRecords: false,//修改成false，可以只引用当前病历
            includeTestReports: false,
            includeHistoryChat: false
          };

          if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
          const resp = await request({
            url: '/ly/archive/create',
            method: 'POST',
            data: payload
          });
          if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

          if (resp && resp.success) {
            const suggestionFields = (resp.result && resp.result.fields) || [];
            console.log('API返回的建议字段:', suggestionFields);

            const hasNoMedicalData = !(this.medicalDetail && Object.keys(this.medicalDetail).length) && !this.activeArchives.length;

            if (hasNoMedicalData) {
              this.createEmptyArchivesWithSuggestions(suggestionFields);
            } else if (this.activeArchives.length > 0) {
              this.mergeArchivesSuggestions(suggestionFields);
            } else {
              this.mergeArchivesSuggestions(suggestionFields);
            }
          } else {
            throw new Error(resp?.message || '同步到病例失败');
          }
        } catch (e) {
          if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
          console.error('同步到病例失败:', e);
          throw new Error('同步到病例失败：' + e.message);
        }

        // 第二步：全部接受AI建议
        this.updateSubmitProgress(2, 60, '正在全部接受AI建议...');
        await new Promise(resolve => setTimeout(resolve, 500));
        this.handleAcceptAll();
        this.$message.success('已全部接受AI建议');

        // 第三步：保存病历
        this.updateSubmitProgress(3, 75, '正在保存病历到数据库...');
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.saveArchives();

        // 第四步：提交到HIS系统
        this.updateSubmitProgress(4, 90, '正在提交到HIS系统...');
        await this.confirmHisSubmit();

        // 完成
        this.completeSubmitProgress();

      } catch (error) {
        console.error('全部接受并提交HIS失败:', error);
        this.failSubmitProgress(error.message || '未知错误');
        this.$message.error('操作失败：' + error.message);
      }
    },

    /* 选择历史病历 */
    selectHistory(historyItem) {
      this.historyVisible = false;
      this.$message.success(`已切换到：${historyItem}`);
      // 这里可以添加切换到对应病历的逻辑
      // 比如根据historyItem查询对应的病历数据
    },

    /* 病历存档（旧AI结构）*/
    async saveArchivesLegacy() {
      if (!this.activeArchives.length) {
        this.$message.warning("当前无病历内容可存档");
        return;
      }
      if (!this.itemCacheChatData?.id) {
        this.$message.warning("请选择会话");
        return;
      }

      const result = await addApi({
        source: "medical_record_archive",
        openid: this.itemCacheChatData?.openid,
        phone: this.itemCacheChatData?.phone,
        message: JSON.stringify(this.activeArchives),
        answerNumber: this.itemCacheChatData?.id
      });

      if (result.code === 200) {
        this.$message.success("病历存档成功");
      } else {
        this.$message.error("病历存档失败");
      }
    },

    /* 选择模板 */
    handleSelectTemplate(templateName) {
      this.selectedTemplateName = templateName;
      // 安全访问refs设置模板
      if (this.$refs.chatBoxDoctor && this.$refs.chatBoxDoctor.init) {
        this.$refs.chatBoxDoctor.selectTemplateName = templateName;
        this.$refs.chatBoxDoctor.init();
      }
    },

    /* 接受 */
    handleAccept(item, index) {
      // 先保存建议值到 value，然后清空建议值
      const newValue = item.isEdit_newValue;
      this.$set(this.activeArchives, index, {
        ...item,
        value: newValue,
        isEdit_newValue: null,
        originalValue: newValue // 更新原始值，避免失焦时再次触发保存
      });

      // 立即保存到服务器，但不会重新加载数据
      this.saveArchives();
      console.log(`已接受字段 ${item.title} 的AI建议:`, newValue);
    },
    /* 拒绝 */
    handleRefuse(item, index) {
      this.$set(this.activeArchives, index, { ...item, isEdit_newValue: null });
    },
    /* 全部采纳 */
    handleAcceptAll() {
      console.log("全部接受AI建议", this.activeArchives);
      let acceptedCount = 0;
      for (let i = 0; i < this.activeArchives.length; i++) {
        if (
          this.activeArchives[i].isEdit_newValue &&
          this.activeArchives[i].isEdit_newValue != "未提供"
        ) {
          const newValue = this.activeArchives[i].isEdit_newValue;
          this.activeArchives[i].value = newValue;
          this.activeArchives[i].isEdit_newValue = null;
          this.activeArchives[i].originalValue = newValue; // 更新原始值，避免失焦时再次触发保存
          acceptedCount++;
        }
      }
      if (acceptedCount > 0) {
        this.saveArchives(true); // 批量操作后重新加载历史数据
        this.$message.success(`已接受 ${acceptedCount} 个AI建议并保存`);
      } else {
        this.$message.warning("没有可接受的AI建议");
      }
    },

    /* 全部拒绝 */
    handleRejectAll() {
      console.log("全部拒绝AI建议", this.activeArchives);
      let rejectedCount = 0;
      for (let i = 0; i < this.activeArchives.length; i++) {
        if (
          this.activeArchives[i].isEdit_newValue &&
          this.activeArchives[i].isEdit_newValue != "未提供"
        ) {
          this.activeArchives[i].isEdit_newValue = null;
          rejectedCount++;
        }
      }
      if (rejectedCount > 0) {
        this.$message.success(`已拒绝 ${rejectedCount} 个AI建议`);
      } else {
        this.$message.warning("没有可拒绝的AI建议");
      }
    },

    /* 处理医疗记录区域点击 - 自动保存编辑中的字段 */
    handleMedicalRecordClick(event) {
      // 查找当前正在编辑的字段并保存
      const editingIndex = this.activeArchives.findIndex(item => item.isEdit);
      if (editingIndex !== -1) {
        const editingItem = this.activeArchives[editingIndex];
        // 检查点击的是否是编辑框本身或其子元素
        const isEditingInput = event.target.closest('.edit-input, .el-textarea, .cancel-edit-btn, .edit-mode');
        if (!isEditingInput) {
          this.saveArchives_item(editingItem, editingIndex);
        }
      }
    },

    /* 查看预问诊对话 */
    viewPreConsultation() {
      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择会话");
      }
      this.type = 1;
      this.isViewingMedicalRecord = false;
      this.$message.success("已切换到预问诊对话记录");
    },

    /* 查看病历 */
    viewMedicalRecord() {
      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择会话");
      }
      this.type = 2;
      this.isViewingMedicalRecord = true;
      this.$message.success("已切换到病历详情");
    },

    /* 切换查看模式 */
    toggleView() {
      if (!this.itemCacheChatData?.id) {
        return this.$message.warning("请选择会话");
      }

      if (this.isViewingMedicalRecord) {
        // 当前查看病历，切换到预问诊对话
        this.type = 1;
        this.isViewingMedicalRecord = false;
        this.$message.success("已切换到预问诊对话记录");
      } else {
        // 当前查看预问诊对话，切换到病历
        this.type = 2;
        this.isViewingMedicalRecord = true;
        this.$message.success("已切换到病历详情");
      }
    },

    /* 确认重置病历 */
    confirmResetMedicalRecord() {
      this.resetVisible = false;
      // 这里可以添加重置病历到预问诊状态的逻辑
      // 比如重新调用提取病历接口，或者从历史记录中恢复初始状态
      this.$message.success("病历已重置到预问诊状态");
    },

    /* 录音状态变化处理 */
    handleRecordingStateChange(state) {
      this.recordingState = { ...state };
    },

    /* 处理切换到聊天会话 */
    async handleSwitchToConversation(conversation) {
      console.log('切换到会话:', conversation);

      if (!conversation || !conversation.id) {
        this.$message.error('会话信息不完整，无法切换。');
        return;
      }

      try {
        // 1. 调用详情接口获取完整的聊天记录
        console.log('调用 /ly/conversation/detail 接口，conversationId:', conversation.id);
        const res = await request({
          url: `/ly/conversation/detail`,
          method: "POST",
          data: { conversationId: conversation.id }
        });

        if (res && res.success && res.result) {
          const messages = res.result.conversationData || [];
          console.log('获取到的会话详情消息:', messages);

          // 2. 映射为UI需要的结构 { role: 'user'|'assistant', content, created_at }
          this.chatData_doctor = messages.map(m => ({
            role: m.senderType === 'doctor' ? 'user' : 'assistant', // 医生发送的视为用户消息
            content: m.content,
            createTime: m.createTime,
            senderType: m.senderType, // 保留原始senderType，可能有用
            id: m.id, // 保留消息ID
            audioFilePath: m.audioFilePath || '' // 加载音频文件路径，支持重新编辑时播放
          }));

          console.log('加载的聊天记录条数:', this.chatData_doctor.length);

          // 3. 更新当前选中的会话信息
          // 只更新必要的字段，避免触发不必要的清空
          this.itemCacheChatData = {
            ...this.itemCacheChatData,
            chatId: conversation.id, // 更新会话ID
            id: conversation.medmstrId || this.itemCacheChatData.id, // 患者ID
            realname: conversation.patientName || this.itemCacheChatData.realname, // 患者姓名
            phone: conversation.phone || this.itemCacheChatData.phone, // 患者电话
            departmentId: conversation.departmentId || this.itemCacheChatData.departmentId
            // 保持其他字段不变，如 age, sex, sexText, visitStatus 等
          };

          const resolvedDepartmentId = this.itemCacheChatData.departmentId || '';
          if (resolvedDepartmentId) {
            this.currentDepartmentId = resolvedDepartmentId;
            localStorage.setItem(CURRENT_PATIENT_DEPARTMENT_ID_KEY, resolvedDepartmentId);
          }

          // 4. 切换到聊天记录视图
          ///this.type = 1;

          // 5. 显示成功消息
          this.$message.success(`已切换到会话：${conversation.patientName || conversation.id}`);

          // 6. 关闭会话历史弹窗
          this.conversationModalVisible = false;

        } else {
          this.$message.error(res?.message || '获取会话详情失败');
          this.chatData_doctor = [];
        }
      } catch (error) {
        console.error('切换会话失败:', error);
        this.$message.error('切换会话失败，请稍后再试。');
        this.chatData_doctor = [];
      }
    },

    /* 批量引用AI回复（已废弃：现在只支持单个引用） */
    async handleBatchQuoteAiReplies(aiReplies) {
      // 功能已废弃，不再支持批量引用功能
      this.$message.warning("该功能已废弃，请使用单个引用功能");
      return;

      /* 废弃代码 - 已屏蔽
      if (!this.itemCacheChatData?.chatId) {
        return this.$message.warning("请选择会话");
      }

      this.type = 2; // 切换到病历视图

      // 批量引用：content 为所选AI回复组成的数组
      const contentPayload = aiReplies.map(item => ({ role: item.role, content: item.content }));
      const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
      const payload = {
        chatId: this.itemCacheChatData.chatId,
        content: JSON.stringify(contentPayload),
        consultationId: this.itemCacheChatData?.id || '',
        professionalId: professionalId,
        departmentId: this.getCurrentDepartmentId(),
        visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
        includeMedicalRecords: true,
        includeTestReports: true,
        includeHistoryChat: true
      };

      try {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          this.mergeArchivesSuggestions(suggestionFields);
          this.$message.success(`已批量引用 ${aiReplies.length} 条AI回复`);
        } else {
          this.$message.error(resp?.message || '批量引用失败');
        }
      } catch (error) {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
        this.$message.error('批量引用失败');
      }
      */
    },

    /* 处理开始新的对话会话 */
    async handleStartNewConversation() {
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      try {
        await this.$confirm('开始新会话将清空当前对话记录，是否继续？', '确认开始新会话', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 清空当前对话记录
        this.chatData_doctor = [];
        this.chatData = [];

        // 重置会话状态
        this.isConversationEnded = false;

        // 创建新的会话ID
        try {
          const result = await createConversationLy({
            medmstrId: this.itemCacheChatData?.id,
            professionalId: localStorage.getItem('userId') || this.userInfo?.id,
            departmentId: this.getCurrentDepartmentId(),
            visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || ''
          });

          if (result.success && result.code === 200) {
            // 更新chatId
            this.itemCacheChatData.chatId = result.result.chatId;

            // 同时更新classData中对应患者的chatId，确保子组件数据同步
            const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
            if (patientIndex !== -1) {
              this.$set(this.classData[patientIndex], 'chatId', result.result.chatId);
            }

            console.log('新会话创建成功，chatId:', result.result.chatId);
          } else {
            this.$message.error(result.message || "创建新会话失败");
            return;
          }
        } catch (error) {
          console.error("创建新会话失败：", error);
          this.$message.error("创建新会话失败，请重试");
          return;
        }

        this.$message.success('已开始新的对话会话');

        // 保持病历视图，不切换视图类型
        // this.type = 1; // 注释掉，保持当前视图

      } catch (e) {
        // 用户取消
      }
    },

    /* 计算当前录音所属的分组（门诊病历不需要分组，返回 undefined） */
    getChatGroupByView() {
      // 门诊病历只有一个病历类型，不需要 chatGroup 分组
      return undefined;
    },

    /* 处理选择录音历史 */
    handleSelectRecordingHistory(recordingItem) {
      if (!recordingItem || !recordingItem.aiReturnMsg) {
        this.$message.warning('录音内容为空');
        return;
      }

      // 将录音内容设置为当前编辑内容
      this.audioMessage = recordingItem.professionalSendMsg;
      // 暂时将两个字段都填充成一样的内容
      this.extractedMessage = recordingItem.aiReturnMsg;
      // 从录音记录中提取音频路径（PC 播放优先 localAudioFilePath）
      this.currentAudioFilePath = this.normalizeAudioSrc(recordingItem.localAudioFilePath || recordingItem.audioFilePath || '');
      this.dialogFormVisible = true;

      this.$message.success('已加载录音历史内容');
    },

    /**
     * PC 播放录音地址规范化（与住院页 getAudioUrl 对齐）：
     * - localAudioFilePath 为 upload/... 时，转换为 /upload/...（同域静态资源）
     * - /upload/... 保持不变
     * - 绝对 URL 保持不变（兼容旧数据）
     * - /ly/asrRecordingAsset/stream/... 须补 API 上下文（生产 /medisyn-hub，开发 /proxy-server）
     */
    normalizeAudioSrc(audioPath) {
      if (!audioPath) return '';
      const trimmed = String(audioPath).trim().replace(/\\/g, '/');
      if (!trimmed) return '';

      if (trimmed.startsWith('upload/')) return '/' + trimmed;
      if (trimmed.startsWith('/upload/')) return trimmed;
      if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;

      let path = trimmed.startsWith('/') ? trimmed : '/' + trimmed;

      // EXE ASR 流式代理：库内为 /ly/asrRecordingAsset/stream/xxx.wav
      const asrMarker = '/ly/asrRecordingAsset/stream';
      const asrIdx = path.indexOf(asrMarker);
      if (asrIdx >= 0) {
        const streamRelative = path.substring(asrIdx);
        const apiBase = String(BASE_URL || '/medisyn-hub').replace(/\/$/, '');
        return apiBase + streamRelative;
      }

      return path;
    },

    /* 处理加载录音历史 */
    async handleLoadRecordingHistory(chatGroup) {
      // 检查是否选择了患者
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择一个患者才能查看录音历史');
        return;
      }

      try {
        const resp = await request({
          url: '/ly/conversation/recordingHistory',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            professionalId: localStorage.getItem('userId') || this.userInfo?.id,
            pageNo: 1,
            pageSize: 10,
            visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || localStorage.getItem('visitNum') || '',
            chatGroup: chatGroup !== undefined && chatGroup !== null && chatGroup !== '' ? chatGroup : undefined
          }
        });

        if (resp && resp.success && resp.result && Array.isArray(resp.result.records)) {
          this.$refs.soundRecording && (this.$refs.soundRecording.recordingHistoryData = resp.result.records);
        } else {
          this.$message.error(resp?.message || '获取录音历史失败');
          this.$refs.soundRecording && (this.$refs.soundRecording.recordingHistoryData = []);
        }
      } catch (error) {
        console.error('加载录音历史失败:', error);
        this.$message.error('加载录音历史失败，请稍后重试');
        this.$refs.soundRecording && (this.$refs.soundRecording.recordingHistoryData = []);
      }
    },

    /* 确认提交到HIS系统 */
    async confirmHisSubmit() {
      try {
        this.hisSubmitLoading = true;

        // 检查是否有患者和病历数据
        if (!this.itemCacheChatData?.id) {
          this.$message.warning('请先选择患者');
          return;
        }

        if (!this.activeArchives || this.activeArchives.length === 0) {
          this.$message.warning('暂无病历内容可提交');
          return;
        }
        console.log("activeArchives:{}",this.activeArchives);
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        if (!professionalId) {
          this.$message.warning('未找到医生ID');
          return;
        }

        // 步骤1：获取需要提交HIS的字段配置
        console.log('步骤1：获取HIS字段配置');
        const departmentId = this.getCurrentDepartmentId();
        if (!departmentId) {
          this.$message.error('未找到科室ID');
          return;
        }

        const hisFieldsResp = await request({
          url: '/ly/archive/fields/template',
          method: 'POST',
          data: {
            professionalId: professionalId,
            departmentId: departmentId,
            showLocation: 'HIS' // 获取HIS字段配置
          }
        });

        if (!hisFieldsResp || !hisFieldsResp.success || !hisFieldsResp.result) {
          this.$message.error('获取HIS字段配置失败');
          return;
        }

        const hisFields = hisFieldsResp.result.fields || [];
        const hisFieldKeys = hisFields.map(f => f.key); // 获取需要提交的字段key列表（下划线命名）
        console.log('需要提交HIS的字段:', hisFieldKeys);

        // 如果没有配置HIS字段，提示用户
        if (hisFieldKeys.length === 0) {
          this.$message.warning('当前科室未配置需要提交HIS的字段，无法提交');
          return;
        }

        // 步骤2：获取HIS提交接口地址
        console.log('步骤2：获取HIS提交接口地址');
        const hisUrlResp = await request({
          url: '/ly/careProfessionals/queryHisUrlById',
          method: 'GET',
          params: { id: professionalId }
        });

        if (!hisUrlResp || !hisUrlResp.success || !hisUrlResp.result) {
          this.$message.error('获取HIS接口地址失败');
          return;
        }

        const hisUrl = hisUrlResp.result;
        console.log('获取到HIS接口地址:', hisUrl);

        // 步骤3：构建提交数据
        const submitData = this.buildHisSubmitData(hisFieldKeys);
        console.log('构建的提交数据:', submitData);

        // 步骤4：调用插入日志接口（提交前）
        console.log('步骤4：插入提交前日志');
        const logResp = await request({
          url: '/ly/archive/addLogForHisCommitBefore',
          method: 'POST',
          data: submitData
        });

        if (!logResp || !logResp.success) {
          this.$message.error('记录提交日志失败');
          return;
        }

        console.log('提交前日志记录成功');

        // 步骤5：调用HIS接口提交数据（跨域请求）
        console.log('步骤5：调用HIS接口提交数据');
        const hisSubmitResp = await this.submitToHis(hisUrl, submitData);

        if (!hisSubmitResp) {
          this.$message.error('HIS系统提交失败');
          return;
        }

        console.log('HIS系统提交成功:', hisSubmitResp);

        // 步骤6：记录HIS返回数据
        console.log('步骤6：记录HIS返回数据');
        const hisResultResp = await request({
          url: '/ly/archive/addLogForHisCommitBefore',
          method: 'POST',
          data: {
            ...submitData,
            hisResponse: JSON.stringify(hisSubmitResp),
            submitStatus: 'success'
          }
        });

        if (hisResultResp && hisResultResp.success) {
          this.$message.success('病历已成功提交到HIS系统');
          this.hisSub = false;
        } else {
          this.$message.warning('HIS提交成功，但记录返回数据失败');
          this.hisSub = false;
        }

      } catch (error) {
        console.error('HIS提交过程出错:', error);
        this.$message.error('HIS提交失败：' + (error.message || '未知错误'));
      } finally {
        this.hisSubmitLoading = false;
      }
    },

    /* 构建HIS提交数据 */
    buildHisSubmitData(hisFieldKeys = []) {
      // 基础数据
      const submitData = {
        consultationId: this.medicalDetail?.consultationId || '',
        medmstrId: this.itemCacheChatData.id,
        visitNum: this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber || '',
        visitDateStr: this.medicalDetail?.visitDate || new Date().toISOString().split('T')[0], // 优先使用medicalDetail中的就诊日期
        patientName: this.itemCacheChatData.realname || '',
        patientPhone: this.itemCacheChatData.phone || '',
        professionalId: localStorage.getItem('userId') || this.userInfo?.id,
        chatId: this.itemCacheChatData.chatId || '',
        // HIS 侧医生与科室 ID（来自患者列表接口返回）
        hisProfessionalId: this.itemCacheChatData.hisProfessionalId || '',
        hisDepartmentId: this.itemCacheChatData.hisDepartmentId || ''
      };

      // 从activeArchives中筛选出需要提交HIS的字段，并转换为驼峰命名
      // activeArchives中的key是下划线命名（如 chief_complaint），需要转换为驼峰命名（如 chiefComplaint）
      if (Array.isArray(this.activeArchives) && this.activeArchives.length > 0) {
        this.activeArchives.forEach(item => {
          // 只处理在HIS字段列表中的字段
          if (hisFieldKeys.includes(item.key)) {
            // 将下划线命名转换为驼峰命名
            const camelKey = this.snakeToCamel(item.key);
            submitData[camelKey] = item.value || '';
          }
        });
      }

      return submitData;
    },

    /* 下划线命名转驼峰命名 */
    snakeToCamel(str) {
      return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
    },

    /* 提交数据到HIS系统（本地测试接口） */
    async submitToHis(hisUrl, submitData) {
      try {
        // 使用本地项目接口进行测试
        //const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImRvY3Rvcl8wMzAzMDEiLCJleHAiOjE3NjEzNTYxOTN9.h4dormIHQ3lVWIPr4hhfSePjNfM7UaGjm--guUJ1jPk';
        console.log('提交数据:', submitData);

        // 使用fetch进行跨域请求，添加token验证
        const response = await fetch(hisUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(submitData),
          mode: 'cors', // 支持跨域
          credentials: 'include' // 包含cookies
        });

        if (!response.ok) {
          throw new Error(`HIS接口请求失败: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        console.log('HIS接口返回结果:', result);
        return result;
      } catch (error) {
        console.error('HIS接口调用失败:', error);
        throw error;
      }
    }
  }
};
</script>


<style scoped lang="less">
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4169e1; /* 统一主蓝色 */
  border: none;
  background: none;
  padding: 0.5rem;
  cursor: pointer;
}
.icon-img {
  width: 1.2rem;
  height: 1.2rem;
  display: block;
}
/* 医疗详情 左右结构样式（本地覆盖，尽量贴近原样式） */
.copy-row-btn {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  appearance: none;
  -webkit-appearance: none;
  color: #4169e1 !important;
  cursor: pointer;
  font-size: 14px;
  padding: 0 !important;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  border-radius: 0 !important;
  flex-shrink: 0;
}

.medical-detail {
  .copy-row-btn {
    margin-top: 4px;
    margin-left: -2px;
    margin-right: 12px;
  }
  .readonly-header {
    margin-bottom: 8px;
    .line { margin: 6px 0; color:#464646; font-size:12px; }
    .label { display:inline-block; width:72px; color:#2c2c2c; font-weight:600; }
    .value { color:#464646; }
  }
  .field-item {
    display: flex;
    align-items: flex-start;
    margin: 12px 0;
    padding: 12px 16px;
    background: #f8faff;
    border-left: 3px solid #4169e1; /* 统一主蓝色 */
    border-radius: 0 8px 8px 0;
    transition: all 0.3s ease;

    > .field-label {
      order: 1;
    }

    > .copy-row-btn {
      order: 2;
    }

    > .field-value {
      order: 3;
    }

    &:hover {
      background: #f0f4ff;
      border-left-color: #5a7ce8;
    }
  }
  .field-label {
    width: 88px;
    color: #4169e1; /* 统一主蓝色 */
    font-weight: 600;
    line-height: 28px;
    padding-top: 4px;
    text-align: left;
    flex-shrink: 0;
    font-size: 14px;
    white-space: nowrap;
  }
  .field-value {
    flex: 1;
    margin-left: 12px;
  }
  .el-textarea, .el-input {
    width: 100%;
  }

}

.field-row-layout {
  display: flex;
  align-items: flex-start;
  gap: 0;
}

.field-title {
  min-width: 88px;
  white-space: nowrap;
  line-height: 22px;
  order: 1;
}

.field-copy-btn {
  order: 2;
  margin-top: 2px;
  margin-left: -2px;
  margin-right: 12px;
}

.field-row-layout > .flex-1 {
  order: 3;
}

/* AI建议按钮样式 - 与底部其他按钮保持一致的高度和样式 */
.ai-suggestion-buttons {
  display: inline-flex;
  gap: 8px;
  margin-left: 8px;
  white-space: nowrap; // 防止换行
  flex-wrap: nowrap; // 防止换行

  ::v-deep .accept-all-btn,
  ::v-deep .reject-all-btn {
    display: inline-flex !important;
    align-items: center !important;
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
    border: none !important;
    border-radius: 9999px !important;
    font-size: 0.75rem !important;
    font-weight: 500 !important;
    line-height: 1rem !important;
    box-sizing: border-box !important;
    line-height: 26px !important;
    margin-right: 0.5rem !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;

    i {
      margin-right: 4px !important;
    }

    &:hover {
      transform: translateY(-3px) !important;
    }

    &:active {
      transform: translateY(-1px) !important;
    }
  }

  ::v-deep .accept-all-btn {
    color: white !important;
    background-color: #34c759 !important;

    &:hover {
      background-color: #2fb344 !important;
      color: white !important;
    }
  }

  ::v-deep .reject-all-btn {
    color: white !important;
    background-color: #d32f2f !important;

    &:hover {
      background-color: #c62828 !important;
      color: white !important;
    }
  }

  // 开始录音按钮hover效果优化 - 增强穿透和特异性
  ::v-deep .soundRecording {
    .sound-recording {
      button.el-tooltip,
      button.round,
      button.item,
      button {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

        &:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
        }
      }
    }
  }

  // 清空病历按钮红色样式 - 增强选择器特异性
  ::v-deep .medical_record,
  ::v-deep .bottom {
    .el-button.del-btn-like-reject {
      background-color: #d32f2f !important;
      color: #fff !important;
      border: none !important;
      border-radius: 9999px !important;
      box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3) !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      font-weight: 500 !important;

      i {
        color: #fff !important;
      }

      &:hover,
      &.hover {
        background-color: #d32f2f !important;
        color: #fff !important;
        border-color: #d32f2f !important;
        opacity: 0.9 !important;
        transform: translateY(-1px) scale(1.1) !important;
        box-shadow: 0 6px 16px rgba(211, 47, 47, 0.4) !important;

        i {
          color: #fff !important;
        }
      }

      &:focus,
      &:active {
        background-color: #d32f2f !important;
        color: #fff !important;
        border-color: #d32f2f !important;
        outline: none !important;
      }
    }
  }

  // 录音内容弹出框优化
  ::v-deep .recording-dialog {
    border-radius: 24px !important;
    overflow: hidden !important;

    .el-dialog {
      border-radius: 24px !important;
    }

    .el-dialog__header {
      padding: 24px 24px 16px;
      font-size: 18px;
      font-weight: 600;
      background: linear-gradient(135deg, #4169e1 0%, #5a7ce8 100%);
      color: #fff;

      .el-dialog__title {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
      }

      .el-dialog__headerbtn {
        top: 24px;
        right: 24px;

        .el-dialog__close {
          color: #fff;
          font-size: 20px;

          &:hover {
            color: #fff;
            opacity: 0.8;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 24px;
      font-size: 15px;
    }

    .editBox {
      .flex-p {
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 12px;
        color: #2c2c2c;
      }

      .el-textarea {
        .el-textarea__inner {
          font-size: 15px !important;
          line-height: 1.6;
          border-radius: 12px;
          border: 2px solid rgba(65, 105, 225, 0.15);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &:focus {
            border: 4px solid #4169e1 !important;
            box-shadow: 0 0 0 4px rgba(65, 105, 225, 0.1);
          }
        }
      }
    }

    .el-dialog__footer {
      padding: 16px 24px 24px;

      .dialog-footer {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        flex-wrap: wrap;

        .el-button {
          padding: 12px 28px !important;
          font-size: 15px;
          min-height: 44px !important;
          border-radius: 10px;
          font-weight: 500;
          line-height: 1.5;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &:hover {
            transform: translateY(-1px);
          }

          &.el-button--primary {
            background-color: #4169e1;
            border-color: #4169e1;
            box-shadow: 0 4px 12px rgba(65, 105, 225, 0.25);

            &:hover {
              background-color: #4169e1;
              opacity: 0.9;
              box-shadow: 0 6px 16px rgba(65, 105, 225, 0.35);
            }
          }

          &.accept-all-submit-btn {
            background-color: #52c41a;
            border-color: #52c41a;
            box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25);
            color: white !important;
            font-weight: 600;
            font-size: 15px;

            &:hover {
              background-color: #389e0d;
              border-color: #389e0d;
              color: white !important;
              box-shadow: 0 6px 16px rgba(82, 196, 26, 0.35);
            }

            i {
              color: white !important;
              margin-right: 6px;
            }
          }
        }
      }
    }
  }

  // 全部接受/全部拒绝按钮固定在右下角
  .ai-suggestion-buttons-fixed {
    position: absolute;
    bottom: 24px;
    right: 24px;
    display: flex;
    gap: 12px;
    z-index: 100;

    .accept-all-btn,
    .reject-all-btn {
      padding: 10px 20px;
      border-radius: 10px;
      font-weight: 500;
      font-size: 14px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      cursor: pointer;
      border: none;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.20);
      }

      i {
        margin-right: 4px;
      }
    }

    .accept-all-btn {
      background-color: #4ade80;
      color: #fff;

      &:hover {
        background-color: #4ade80;
        opacity: 0.9;
      }
    }

    .reject-all-btn {
      background-color: #d32f2f;
      color: #fff;

      &:hover {
        background-color: #d32f2f;
        opacity: 0.9;
      }
    }
  }

  // 全局弹框样式优化
  ::v-deep .el-dialog {
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);

    .el-dialog__header {
      background: linear-gradient(135deg, #4169e1 0%, #5a7ce8 100%);
      padding: 24px;

      .el-dialog__title {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
      }

      .el-dialog__headerbtn {
        top: 24px;
        right: 24px;

        .el-dialog__close {
          color: #fff;
          font-size: 20px;

          &:hover {
            color: #fff;
            opacity: 0.8;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 24px;
      font-size: 15px;
      line-height: 1.6;
    }

    .el-dialog__footer {
      padding: 16px 24px 24px;

      .el-button {
        padding: 12px 28px;
        font-size: 15px;
        min-height: 44px;
        border-radius: 10px;
        font-weight: 500;
        line-height: 1.5;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          transform: translateY(-1px);
        }

        &--primary {
          background-color: #4169e1 !important;
          border-color: #4169e1 !important;
          box-shadow: 0 4px 12px rgba(65, 105, 225, 0.25);

          &:hover {
            opacity: 0.9;
            box-shadow: 0 6px 16px rgba(65, 105, 225, 0.35);
          }
        }
      }
    }
  }

  // 快速提交进度模态框样式
  ::v-deep .quick-submit-modal {
    .el-dialog {
      border-radius: 24px !important;
      overflow: hidden !important;
    }

    .el-dialog__header {
      padding: 24px 24px 16px;
      font-size: 18px;
      font-weight: 600;
      background: linear-gradient(135deg, #4169e1 0%, #5a7ce8 100%);
      color: #fff;

      .el-dialog__title {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .el-dialog__body {
      padding: 32px;
    }

    .quick-submit-content {
      .progress-section {
        margin-bottom: 32px;

        .progress-text {
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 16px;
          text-align: center;
        }

        .el-progress {
          .el-progress-bar__outer {
            border-radius: 10px;
          }

          .el-progress-bar__inner {
            border-radius: 10px;
            transition: width 0.3s ease;
          }
        }
      }

      .steps-list {
        .step-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 20px;
          padding: 16px;
          border-radius: 12px;
          transition: all 0.3s ease;

          &.step-active {
            background: #f0f4ff;
            border: 1px solid #4169e1;
          }

          &.step-completed {
            background: #f0fdf4;
            border: 1px solid #22c55e;
          }

          &.step-waiting {
            background: #f9fafb;
            border: 1px solid #e5e7eb;
          }

          .step-icon {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin-right: 16px;
            flex-shrink: 0;

            .step-success {
              color: #22c55e;
              font-size: 20px;
              font-weight: bold;
            }

            .step-loading {
              color: #4169e1;
              font-size: 20px;
            }

            .step-waiting-icon {
              color: #d1d5db;
              font-size: 18px;
            }
          }

          .step-content {
            flex: 1;

            .step-title {
              font-size: 16px;
              font-weight: 600;
              color: #1a1a1a;
              margin-bottom: 4px;
            }

            .step-desc {
              font-size: 14px;
              color: #6b7280;
              line-height: 1.5;
            }
          }

          &.step-completed .step-title {
            color: #15803d;
          }

          &.step-waiting .step-title,
          &.step-waiting .step-desc {
            color: #9ca3af;
          }
        }
      }

      .error-message {
        display: flex;
        align-items: center;
        padding: 16px;
        background: #fef2f2;
        border: 1px solid #fca5a5;
        border-radius: 12px;
        color: #dc2626;
        font-size: 14px;
        margin-top: 20px;

        i {
          font-size: 20px;
          margin-right: 8px;
        }
      }
    }

    .el-dialog__footer {
      padding: 16px 24px 24px;

      .dialog-footer {
        display: flex;
        justify-content: center;

        .el-button {
          padding: 12px 32px;
          font-size: 15px;
          min-height: 44px;
          border-radius: 10px;
          font-weight: 500;
          line-height: 1.5;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &:hover {
            transform: translateY(-1px);
          }
        }
      }
    }
  }
}
</style>


<style lang="less" src="@/assets/style/pages/management/aiService/index.less"></style>
